import enPages from '../en-US/pages';

export default {
  ...enPages,
  'pages.superH.loadPlatformConfigsFailed': '{platform} 設定の読み込みに失敗しました。再試行してください。',
  'pages.superH.noPlatformConfigTitle': '{platform} 設定がありません',
  'pages.superH.noPlatformConfigDescription': '送信元と送信先に使用する {platform} 回伝設定を2つ以上作成してください。',
  'pages.superH.platformSourcePlaceholder': '送信元の {platform} 設定を選択',
  'pages.superH.platformTargetPlaceholder': '送信先の {platform} 設定を選択',
  'pages.superH.collectClickRecords': 'クリック記録を収集',
  'pages.adCallbackForm.tiktok.contentType': 'コンテンツタイプ',
  'pages.adCallbackForm.tiktok.contentTypeHelp': '通常の回伝とスーパー回伝で共通の設定です。Contact、Lead、SubmitForm イベントでは商品パラメーターを送信しません。',
  'pages.adCallbackForm.tiktok.contentType.product': '商品（product）',
  'pages.adCallbackForm.tiktok.contentType.productGroup': '商品グループ（product_group）',
  'pages.overseas.batchDelete': '一括削除',
  'pages.overseas.batchDeleteWithCount': '一括削除 ({count})',
  'pages.overseas.batchDeleteEmpty': '削除する振り分けサービスを選択してください',
  'pages.overseas.batchDeleteConfirmTitle':
    '選択した {count} 件の振り分けサービスを削除しますか？',
  'pages.overseas.batchDeleteConfirmContent':
    'この操作は元に戻せません。選択内容を確認してください。',
  'pages.overseas.confirmDelete': '削除',
  'pages.overseas.cancel': 'キャンセル',
  'pages.overseas.cancelSelection': '選択を解除',
  'pages.overseas.batchDeleteSuccess': '{count} 件の振り分けサービスを削除しました',
  'pages.overseas.batchDeletePartial':
    '{success} 件を削除し、{failed} 件は削除できませんでした',
  'pages.overseas.batchDeleteFailed': '一括削除に失敗しました',

  'pages.kakao.title': 'Kakaoサービス管理',
  'pages.kakao.subtitle':
    'Kakao の海外振り分けサービスを管理し、複数ドメインとアクセスルール設定に対応します',
  'pages.kakao.addLink': 'リンクを追加',
  'pages.kakao.refresh': '更新',
  'pages.kakao.export': 'エクスポート',
  'pages.kakao.name': '名称',
  'pages.kakao.quantity': '数量',
  'pages.kakao.configured': '設定済み',
  'pages.kakao.rule': 'ルール',
  'pages.kakao.ruleOrder': '順序',
  'pages.kakao.ruleRandom': 'ランダム',
  'pages.kakao.lockIP': 'IP固定',
  'pages.kakao.locked': '固定済み',
  'pages.kakao.unlocked': '未固定',
  'pages.kakao.status': '状態',
  'pages.kakao.enabled': '有効',
  'pages.kakao.disabled': '無効',
  'pages.kakao.createdAt': '作成日時',
  'pages.kakao.actions': '操作',
  'pages.kakao.copy': 'コピー',
  'pages.kakao.copySuccess': 'リンクをクリップボードにコピーしました',
  'pages.kakao.copyError': 'コピーに失敗しました',
  'pages.kakao.edit': '編集',
  'pages.kakao.delete': '削除',
  'pages.kakao.deleteConfirm': 'この項目を削除してもよろしいですか？',
  'pages.kakao.yes': '確認',
  'pages.kakao.no': 'キャンセル',
  'pages.kakao.addTitle': 'リンクを追加',
  'pages.kakao.editTitle': 'リンクを編集',
  'pages.kakao.serviceName': 'サービス名',
  'pages.kakao.serviceNamePlaceholder': 'サービス名を入力してください',
  'pages.kakao.serviceNameRequired': 'サービス名を入力してください',
  'pages.kakao.domains': 'リンク',
  'pages.kakao.domainsPlaceholder':
    '1 行に 1 件入力し、複数は改行で区切ってください',
  'pages.kakao.domainsRequired': '少なくとも 1 件のリンクを入力してください',
  'pages.kakao.domainsInvalid':
    'ドメイン形式が正しくありません。kakao.com とそのサブドメインのみ使用できます',
  'pages.kakao.deleteAccounts': 'アカウント削除',
  'pages.kakao.deleteAccountsPlaceholder':
    '削除するリンク/アカウントを入力してください',
  'pages.kakao.deleteAccountsExtra':
    '削除するリンク/アカウントを入力してください',
  'pages.kakao.deleteAccountsRemoved': '{count} 件のアカウントを削除しました',
  'pages.kakao.configuredCount': '設定済み',
  'pages.kakao.configuredLinks': '件のリンク',
  'pages.kakao.accessRule': 'アクセスルール',
  'pages.kakao.accessRulePlaceholder': 'アクセスルールを選択してください',
  'pages.kakao.accessRuleRequired': 'アクセスルールを選択してください',
  'pages.kakao.accessRuleOrder': '順序 - ドメインを順番に表示',
  'pages.kakao.accessRuleRandom': 'ランダム - ドメインをランダムに選択',
  'pages.kakao.fetchSuccess': 'サービス一覧を取得しました',
  'pages.kakao.fetchError': 'サービス一覧の取得に失敗しました',
  'pages.kakao.deleteSuccess': '削除しました',
  'pages.kakao.deleteError': '削除に失敗しました',
  'pages.kakao.updateSuccess': '更新しました',
  'pages.kakao.updateError': '更新に失敗しました',
  'pages.kakao.addSuccess': '追加しました',
  'pages.kakao.addError': '追加に失敗しました',
  'pages.kakao.exportDev': 'エクスポート機能は現在開発中です...',
  'pages.kakao.totalRecords': '全 {total} 件',
  'pages.kakao.duplicateRemoved': '{count} 件の重複リンクを自動的に削除しました',
  'pages.kakao.trafficDataSuccess': '振り分けデータを読み込みました',
  'pages.kakao.trafficDataError': '振り分けデータの読み込みに失敗しました',
  'pages.kakao.resetConfirmTitle': 'リセット確認',
  'pages.kakao.resetConfirmLine1': 'この操作は元に戻せません:',
  'pages.kakao.resetConfirmLine2': '訪問記録をクリアしてもよろしいですか？',
  'pages.kakao.resetButton': 'データをリセット',
  'pages.kakao.resetSuccess': '統計データを完全にクリアしました',
  'pages.kakao.updateLinkTitle': 'リンク内容を編集',
  'pages.kakao.currentContent': '現在の内容',
  'pages.kakao.newLinkPlaceholder': '新しいリンクを入力してください',
  'pages.kakao.linkEmpty': 'リンクは空にできません',
  'pages.kakao.linkUpdateSuccess': 'リンク内容を更新しました',
  'pages.kakao.unknownError': '不明なエラー',
  'pages.kakao.operationFailed': '操作に失敗しました',
  'pages.kakao.remarkTitle': '備考を設定',
  'pages.kakao.remarkPlaceholder': '備考を入力してください',
  'pages.kakao.remarkSuccess': '備考を更新しました',
  'pages.kakao.dailyUV': '本日UV/昨日UV',
  'pages.kakao.dailyUVTooltip': '本日/昨日のユニーク訪問者数',
  'pages.kakao.workOrderIncrease': '本日追加/累計追加',
  'pages.kakao.batchLock': '一括固定',
  'pages.kakao.unset': '未設定',
  'pages.kakao.stats': 'アクセス統計',
  'pages.kakao.trafficData': '振り分けデータ',
  'pages.kakao.interceptionConfig': 'インターセプト設定',
  'pages.kakao.generateQr': 'QRコード生成',
  'pages.kakao.exportIp': 'IPエクスポート',
  'pages.kakao.recreateShortLink': '短縮リンクを生成するにはサービスを再作成してください',
  'pages.kakao.copyCampaignLink': '広告リンクをコピー',
  'pages.kakao.moreActions': 'その他の操作',
  'pages.kakao.shareService': 'サービスを共有',
  'pages.kakao.searchPlaceholder': 'サービス名を検索',
  'pages.kakao.workOrderManagement': 'ワークオーダー管理',
  'pages.kakao.favorite': 'お気に入り',
  'pages.kakao.unfavorite': 'お気に入り解除',
  'pages.kakao.favoriteOnly': 'お気に入りのみ',
  'pages.kakao.favoriteSuccess': 'お気に入りに追加しました',
  'pages.kakao.unfavoriteSuccess': 'お気に入りを解除しました',
  'pages.kakao.favoriteToggleFailed': 'お気に入りの更新に失敗しました',
  'pages.kakao.viewAll': 'すべて表示',
  'pages.kakao.workOrderOnly': 'ワークオーダーのみ',
  'pages.kakao.batchDedupe': '一括重複排除',
  'pages.kakao.myIpLibrary': 'マイIPライブラリ',
  'pages.kakao.lockIPTooltip':
    '有効にすると、ブラウザフィンガープリントと IP の重複排除により、同じ訪問者には 1 つの振り分け先のみ表示されます',
  'pages.kakao.trafficStatsTitle': '振り分けデータ統計 - {name}',
  'pages.kakao.close': '閉じる',
  'pages.kakao.refreshData': 'データを更新',
  'pages.kakao.showingRecords': '{total} 件中 {filtered} 件を表示',
  'pages.kakao.customerLink': '顧客リンク',
  'pages.kakao.workOrderIds': '紐付け',
  'pages.kakao.percentage': '割合%',
  'pages.kakao.disabledManual': '無効（手動）',
  'pages.kakao.disabledFlowOptimize': '無効（フロー最適化）',
  'pages.kakao.disabledAuto': '無効（自動）',
  'pages.kakao.disabledManualTooltip':
    '手動で無効化したアカウントは、同期時に自動で再有効化されません',
  'pages.kakao.disabledFlowOptimizeTooltip':
    '本日のワークオーダーしきい値到達後にフロー最適化で無効化され、手動でのみ再有効化できます',
  'pages.kakao.disabledAutoTooltip':
    '自動ルールによって無効化され、手動で再有効化できます',
  'pages.kakao.setRemark': '備考を設定',
  'pages.kakao.batchLockTitle': '一括IP固定設定',
  'pages.kakao.batchLockDesc':
    '同じ IP 重複排除グループを共有するサービスを選択してください',
  'pages.kakao.batchLockPlaceholder': 'グループ名を入力してください（必須）',
  'pages.kakao.selectedServices': '{count} 件のサービスを選択済み',
  'pages.kakao.exportSuccess': 'エクスポートしました',
  'pages.kakao.pageRange': '{start}-{end} / {total}',
  'pages.kakao.batchDedupeRequired': '少なくとも 1 件のサービスを選択してください',
  'pages.kakao.batchDedupeSuccess': '{count} 件のサービスを更新しました',
  'pages.kakao.unbindBatchLockConfirmTitle':
    '現在の重複排除グループとの紐付けを解除しますか？',
  'pages.kakao.unbindBatchLockConfirmDesc':
    '解除後、このサービスはこの一括重複排除グループに属さなくなります。',
  'pages.kakao.unbindBatchLockConfirmOk': '解除',
  'pages.kakao.unbindBatchLockSuccess':
    '一括重複排除の紐付けを解除しました',
  'pages.kakao.deviceRouting': 'デバイス振り分け',
  'pages.kakao.deviceRoutingTitle': 'デバイス振り分け設定 - {name}',
  'pages.kakao.deviceRoutingSave': '保存',
  'pages.kakao.deviceRoutingSaveSuccess': 'デバイス振り分け設定を保存しました',
  'pages.kakao.deviceRoutingSaveError': 'デバイス振り分け設定の保存に失敗しました',
  'pages.kakao.deviceRoutingNoLinks': '設定可能なリンクがありません',
  'pages.kakao.deviceRoutingLink': 'リンク',
  'pages.kakao.deviceRoutingTagAll': '全デバイス',
  'pages.kakao.deviceRoutingTagIOS': 'iOSのみ',
  'pages.kakao.deviceRoutingTagAndroid': 'Androidのみ',
  'pages.kakao.requestFailed': 'リクエストに失敗しました',
  'pages.kakao.maxDomains': 'ドメインは最大 5000 件までです',

  'pages.line.title': 'Lineサービス管理',
  'pages.line.subtitle':
    'Line の海外振り分けサービスを管理し、複数ドメインとアクセスルール設定に対応します',
  'pages.line.addLink': 'リンクを追加',
  'pages.line.refresh': '更新',
  'pages.line.export': 'エクスポート',
  'pages.line.name': '名称',
  'pages.line.quantity': '数量',
  'pages.line.configured': '設定済み',
  'pages.line.rule': 'ルール',
  'pages.line.ruleOrder': '順序',
  'pages.line.ruleRandom': 'ランダム',
  'pages.line.lockIP': 'IP固定',
  'pages.line.locked': '固定済み',
  'pages.line.unlocked': '未固定',
  'pages.line.status': '状態',
  'pages.line.enabled': '有効',
  'pages.line.disabled': '無効',
  'pages.line.createdAt': '作成日時',
  'pages.line.actions': '操作',
  'pages.line.copy': 'コピー',
  'pages.line.copySuccess': 'リンクをクリップボードにコピーしました',
  'pages.line.copyError': 'コピーに失敗しました',
  'pages.line.edit': '編集',
  'pages.line.delete': '削除',
  'pages.line.deleteConfirm': 'この項目を削除してもよろしいですか？',
  'pages.line.yes': '確認',
  'pages.line.no': 'キャンセル',
  'pages.line.addTitle': 'リンクを追加',
  'pages.line.editTitle': 'リンクを編集',
  'pages.line.serviceName': 'サービス名',
  'pages.line.serviceNamePlaceholder': 'サービス名を入力してください',
  'pages.line.serviceNameRequired': 'サービス名を入力してください',
  'pages.line.domains': 'リンク',
  'pages.line.domainsPlaceholder':
    '1 行に 1 件入力し、複数は改行で区切ってください',
  'pages.line.domainsRequired': '少なくとも 1 件のリンクを入力してください',
  'pages.line.domainsInvalid':
    'リンク形式が正しくありません。line.me と公式 Line リンクのみ使用できます',
  'pages.line.deleteAccounts': 'アカウント削除',
  'pages.line.deleteAccountsPlaceholder':
    '@468rqiiq（1行に1つのリンクまたはアカウント）',
  'pages.line.deleteAccountsExtra':
    '完全なリンクまたはLINE IDを入力できます。@アカウントを入力すると対応するoaMessageリンク全体を削除します。手動管理のみ対象で、作業指示書連携には適用されません。',
  'pages.line.deleteAccountsRemoved': '{count} 件のアカウントを削除しました',
  'pages.line.configuredCount': '設定済み',
  'pages.line.configuredLinks': '件のリンク',
  'pages.line.accessRule': 'アクセスルール',
  'pages.line.accessRulePlaceholder': 'アクセスルールを選択してください',
  'pages.line.accessRuleRequired': 'アクセスルールを選択してください',
  'pages.line.accessRuleOrder': '順序 - 順番に表示',
  'pages.line.accessRuleRandom': 'ランダム - ランダムに表示',
  'pages.line.fetchSuccess': 'サービス一覧を取得しました',
  'pages.line.fetchError': 'サービス一覧の取得に失敗しました',
  'pages.line.deleteSuccess': '削除しました',
  'pages.line.deleteError': '削除に失敗しました',
  'pages.line.updateSuccess': '更新しました',
  'pages.line.updateError': '更新に失敗しました',
  'pages.line.addSuccess': '追加しました',
  'pages.line.addError': '追加に失敗しました',
  'pages.line.exportDev': 'エクスポート機能は現在開発中です...',
  'pages.line.totalRecords': '全 {total} 件',
  'pages.line.duplicateRemoved': '{count} 件の重複リンクを自動的に削除しました',
  'pages.line.trafficDataSuccess': '振り分けデータを読み込みました',
  'pages.line.trafficDataError': '振り分けデータの読み込みに失敗しました',
  'pages.line.resetConfirmTitle': 'リセット確認',
  'pages.line.resetConfirmLine1': 'この操作は元に戻せません:',
  'pages.line.resetConfirmLine2': '訪問記録をクリアしてもよろしいですか？',
  'pages.line.resetButton': 'データをリセット',
  'pages.line.resetSuccess': '統計データを完全にクリアしました',
  'pages.line.updateLinkTitle': 'リンク内容を編集',
  'pages.line.currentContent': '現在の内容',
  'pages.line.newLinkPlaceholder': '新しいリンクまたは ID を入力してください',
  'pages.line.linkEmpty': 'リンクまたは ID は空にできません',
  'pages.line.linkUpdateSuccess': 'リンク内容を更新しました',
  'pages.line.unknownError': '不明なエラー',
  'pages.line.operationFailed': '操作に失敗しました',
  'pages.line.remarkTitle': '備考を設定',
  'pages.line.remarkPlaceholder': '備考を入力してください',
  'pages.line.remarkSuccess': '備考を更新しました',
  'pages.line.dailyUV': '本日UV/昨日UV',
  'pages.line.dailyUVTooltip': '本日/昨日のユニーク訪問者数',
  'pages.line.workOrderIncrease': '本日追加/累計追加',
  'pages.line.batchLock': '一括固定',
  'pages.line.unset': '未設定',
  'pages.line.stats': 'アクセス統計',
  'pages.line.trafficData': '振り分けデータ',
  'pages.line.interceptionConfig': 'インターセプト設定',
  'pages.line.generateQr': 'QRコード生成',
  'pages.line.exportIp': 'IPエクスポート',
  'pages.line.recreateShortLink': '短縮リンクを生成するにはサービスを再作成してください',
  'pages.line.copyCampaignLink': '広告リンクをコピー',
  'pages.line.moreActions': 'その他の操作',
  'pages.line.shareService': 'サービスを共有',
  'pages.line.searchPlaceholder': '名前・コード・アカウント・リンク・備考を検索',
  'pages.line.workOrderManagement': 'ワークオーダー管理',
  'pages.line.favorite': 'お気に入り',
  'pages.line.unfavorite': 'お気に入り解除',
  'pages.line.favoriteOnly': 'お気に入りのみ',
  'pages.line.favoriteSuccess': 'お気に入りに追加しました',
  'pages.line.unfavoriteSuccess': 'お気に入りを解除しました',
  'pages.line.favoriteToggleFailed': 'お気に入りの更新に失敗しました',
  'pages.line.viewAll': 'すべて表示',
  'pages.line.workOrderOnly': 'ワークオーダーのみ',
  'pages.line.batchDedupe': '一括重複排除',
  'pages.line.myIpLibrary': 'マイIPライブラリ',
  'pages.line.lockIPTooltip':
    '有効にすると、ブラウザフィンガープリントと IP の重複排除により、同じ訪問者には 1 つの振り分け先のみ表示されます',
  'pages.line.trafficStatsTitle': '振り分けデータ統計 - {name}',
  'pages.line.close': '閉じる',
  'pages.line.refreshData': 'データを更新',
  'pages.line.showingRecords': '{total} 件中 {filtered} 件を表示',
  'pages.line.customerLink': '顧客リンク',
  'pages.line.workOrderIds': '紐付け',
  'pages.line.percentage': '割合%',
  'pages.line.disabledManual': '無効（手動）',
  'pages.line.disabledFlowOptimize': '無効（フロー最適化）',
  'pages.line.disabledAuto': '無効（自動）',
  'pages.line.disabledManualTooltip':
    '手動で無効化したアカウントは、同期時に自動で再有効化されません',
  'pages.line.disabledFlowOptimizeTooltip':
    '本日のワークオーダーしきい値到達後にフロー最適化で無効化され、手動でのみ再有効化できます',
  'pages.line.disabledAutoTooltip':
    '自動ルールによって無効化され、手動で再有効化できます',
  'pages.line.setRemark': '備考を設定',
  'pages.line.batchLockTitle': '一括IP固定設定',
  'pages.line.batchLockDesc':
    '同じ IP 重複排除グループを共有するサービスを選択してください',
  'pages.line.batchLockPlaceholder': 'グループ名を入力してください（必須）',
  'pages.line.selectedServices': '{count} 件のサービスを選択済み',
  'pages.line.exportSuccess': 'エクスポートしました',
  'pages.line.pageRange': '{start}-{end} / {total}',
  'pages.line.batchDedupeRequired': '少なくとも 1 件のサービスを選択してください',
  'pages.line.batchDedupeSuccess': '{count} 件のサービスを更新しました',
  'pages.line.unbindBatchLockConfirmTitle':
    '現在の重複排除グループとの紐付けを解除しますか？',
  'pages.line.unbindBatchLockConfirmDesc':
    '解除後、このサービスはこの一括重複排除グループに属さなくなります。',
  'pages.line.unbindBatchLockConfirmOk': '解除',
  'pages.line.unbindBatchLockSuccess':
    '一括重複排除の紐付けを解除しました',
  'pages.line.deviceRouting': 'デバイス振り分け',
  'pages.line.deviceRoutingTitle': 'デバイス振り分け設定 - {name}',
  'pages.line.deviceRoutingSave': '保存',
  'pages.line.deviceRoutingSaveSuccess': 'デバイス振り分け設定を保存しました',
  'pages.line.deviceRoutingSaveError': 'デバイス振り分け設定の保存に失敗しました',
  'pages.line.deviceRoutingNoLinks': '設定可能なリンクがありません',
  'pages.line.deviceRoutingLink': 'リンク',
  'pages.line.deviceRoutingTagAll': '全デバイス',
  'pages.line.deviceRoutingTagIOS': 'iOSのみ',
  'pages.line.deviceRoutingTagAndroid': 'Androidのみ',
  'pages.line.requestFailed': 'リクエストに失敗しました',
  'pages.line.maxDomains': '最大 5000 件まで入力できます',
  'pages.line.idRequired': '少なくとも 1 件の Line ID を入力してください',
  'pages.line.idLabel': 'Line ID',
  'pages.line.redirectType': '遷移タイプ',
  'pages.line.redirectTypeRequired': '遷移タイプを選択してください',
  'pages.line.redirectTypePlaceholder': '遷移タイプを選択してください',
  'pages.line.redirectLink': 'リンク遷移',
  'pages.line.redirectId': 'Line ID',
  'pages.line.idPlaceholder': '1 行に 1 件の Line ID を入力してください',
  'pages.line.idLengthInvalid': 'Line ID は 4〜20 文字で入力してください: {value}',
  'pages.line.idFormatInvalid':
    'Line ID は先頭の @、英字、数字、ドット、アンダースコア、ハイフンのみ使用できます: {value}',
  'pages.line.linkFormatInvalid':
    'リンク形式が正しくありません。公式 Line リンクのみ使用できます: {value}',

  'pages.tg.title': 'Telegram振り分け管理',
  'pages.tg.subtitle': 'Telegram振り分け管理',
  'pages.tg.addLink': 'サービスを追加',
  'pages.tg.refresh': '更新',
  'pages.tg.name': '名称',
  'pages.tg.quantity': '数量',
  'pages.tg.rule': 'アクセスルール',
  'pages.tg.ruleOrder': '順序',
  'pages.tg.ruleRandom': 'ランダム',
  'pages.tg.lockIP': 'IP固定',
  'pages.tg.locked': '固定済み',
  'pages.tg.unlocked': '未固定',
  'pages.tg.status': '状態',
  'pages.tg.enabled': '有効',
  'pages.tg.disabled': '無効',
  'pages.tg.createdAt': '作成日時',
  'pages.tg.actions': '操作',
  'pages.tg.copySuccess': 'コピーしました',
  'pages.tg.copyError': 'コピーに失敗しました',
  'pages.tg.edit': '編集',
  'pages.tg.delete': '削除',
  'pages.tg.deleteConfirm': 'このサービスを削除してもよろしいですか？',
  'pages.tg.addTitle': 'サービスを追加',
  'pages.tg.editTitle': 'サービスを編集',
  'pages.tg.serviceName': 'サービス名',
  'pages.tg.serviceNamePlaceholder': 'サービス名を入力してください',
  'pages.tg.serviceNameRequired': 'サービス名を入力してください',
  'pages.tg.fetchSuccess': 'Telegram サービスを読み込みました',
  'pages.tg.fetchError': 'データの読み込みに失敗しました',
  'pages.tg.deleteSuccess': '削除しました',
  'pages.tg.deleteError': '削除に失敗しました',
  'pages.tg.updateSuccess': '更新しました',
  'pages.tg.updateError': '更新に失敗しました',
  'pages.tg.addSuccess': '作成しました',
  'pages.tg.addError': '作成に失敗しました',
  'pages.tg.duplicateRemoved': '{count} 件の重複項目を自動的に削除しました',
  'pages.tg.deleteAccounts': 'アカウント削除',
  'pages.tg.deleteAccountsPlaceholder':
    '削除するリンク/アカウントを入力してください',
  'pages.tg.deleteAccountsExtra': '削除するリンク/アカウントを入力してください',
  'pages.tg.deleteAccountsRemoved': '{count} 件のアカウントを削除しました',
  'pages.tg.totalRecords': '全 {total} 件',
  'pages.tg.trafficDataSuccess': '振り分けデータを読み込みました',
  'pages.tg.trafficDataError': '振り分けデータの読み込みに失敗しました',
  'pages.tg.resetConfirmTitle': 'リセット確認',
  'pages.tg.resetConfirmLine1': 'この操作は元に戻せません:',
  'pages.tg.resetConfirmLine2': '訪問記録をクリアしてもよろしいですか？',
  'pages.tg.resetButton': 'データをリセット',
  'pages.tg.resetSuccess': '統計データを完全にクリアしました',
  'pages.tg.updateLinkTitle': 'リンク内容を編集',
  'pages.tg.currentContent': '現在の内容',
  'pages.tg.newLinkPlaceholder': '新しいリンクまたはユーザー名を入力してください',
  'pages.tg.linkEmpty': 'リンクまたはユーザー名は空にできません',
  'pages.tg.linkUpdateSuccess': 'リンク内容を更新しました',
  'pages.tg.unknownError': '不明なエラー',
  'pages.tg.operationFailed': '操作に失敗しました',
  'pages.tg.remarkTitle': '備考を設定',
  'pages.tg.remarkPlaceholder': '備考を入力してください',
  'pages.tg.remarkSuccess': '備考を更新しました',
  'pages.tg.dailyUV': '本日UV/昨日UV',
  'pages.tg.dailyUVTooltip': '本日/昨日のユニーク訪問者数',
  'pages.tg.workOrderIncrease': '本日追加/累計追加',
  'pages.tg.batchLock': '一括固定',
  'pages.tg.unset': '未設定',
  'pages.tg.stats': 'アクセス統計',
  'pages.tg.trafficData': '振り分けデータ',
  'pages.tg.interceptionConfig': 'インターセプト設定',
  'pages.tg.generateQr': 'QRコード生成',
  'pages.tg.exportIp': 'IPエクスポート',
  'pages.tg.recreateShortLink': '短縮リンクを生成するにはサービスを再作成してください',
  'pages.tg.copyCampaignLink': '広告リンクをコピー',
  'pages.tg.moreActions': 'その他の操作',
  'pages.tg.shareService': 'サービスを共有',
  'pages.tg.searchPlaceholder': '名前・コード・アカウント・リンク・備考を検索',
  'pages.tg.workOrderManagement': 'ワークオーダー管理',
  'pages.tg.favorite': 'お気に入り',
  'pages.tg.unfavorite': 'お気に入り解除',
  'pages.tg.favoriteOnly': 'お気に入りのみ',
  'pages.tg.favoriteSuccess': 'お気に入りに追加しました',
  'pages.tg.unfavoriteSuccess': 'お気に入りを解除しました',
  'pages.tg.favoriteToggleFailed': 'お気に入りの更新に失敗しました',
  'pages.tg.viewAll': 'すべて表示',
  'pages.tg.workOrderOnly': 'ワークオーダーのみ',
  'pages.tg.batchDedupe': '一括重複排除',
  'pages.tg.myIpLibrary': 'マイIPライブラリ',
  'pages.tg.lockIPTooltip':
    '有効にすると、ブラウザフィンガープリントと IP の重複排除により、同じ訪問者には 1 つの振り分け先のみ表示されます',
  'pages.tg.trafficStatsTitle': '振り分けデータ統計 - {name}',
  'pages.tg.close': '閉じる',
  'pages.tg.refreshData': 'データを更新',
  'pages.tg.showingRecords': '{total} 件中 {filtered} 件を表示',
  'pages.tg.customerLink': '顧客リンク',
  'pages.tg.workOrderIds': '紐付け',
  'pages.tg.percentage': '割合%',
  'pages.tg.disabledManual': '無効（手動）',
  'pages.tg.disabledFlowOptimize': '無効（フロー最適化）',
  'pages.tg.disabledAuto': '無効（自動）',
  'pages.tg.disabledManualTooltip':
    '手動で無効化したアカウントは、同期時に自動で再有効化されません',
  'pages.tg.disabledFlowOptimizeTooltip':
    '本日のワークオーダーしきい値到達後にフロー最適化で無効化され、手動でのみ再有効化できます',
  'pages.tg.disabledAutoTooltip':
    '自動ルールによって無効化され、手動で再有効化できます',
  'pages.tg.setRemark': '備考を設定',
  'pages.tg.batchLockTitle': '一括IP固定設定',
  'pages.tg.batchLockDesc':
    '同じ IP 重複排除グループを共有するサービスを選択してください',
  'pages.tg.batchLockPlaceholder': 'グループ名を入力してください（必須）',
  'pages.tg.selectedServices': '{count} 件のサービスを選択済み',
  'pages.tg.exportSuccess': 'エクスポートしました',
  'pages.tg.pageRange': '{start}-{end} / {total}',
  'pages.tg.batchDedupeRequired': '少なくとも 1 件のサービスを選択してください',
  'pages.tg.batchDedupeSuccess': '{count} 件のサービスを更新しました',
  'pages.tg.unbindBatchLockConfirmTitle':
    '現在の重複排除グループとの紐付けを解除しますか？',
  'pages.tg.unbindBatchLockConfirmDesc':
    '解除後、このサービスはこの一括重複排除グループに属さなくなります。',
  'pages.tg.unbindBatchLockConfirmOk': '解除',
  'pages.tg.unbindBatchLockSuccess':
    '一括重複排除の紐付けを解除しました',
  'pages.tg.deviceRouting': 'デバイス振り分け',
  'pages.tg.deviceRoutingTitle': 'デバイス振り分け設定 - {name}',
  'pages.tg.deviceRoutingSave': '保存',
  'pages.tg.deviceRoutingSaveSuccess': 'デバイス振り分け設定を保存しました',
  'pages.tg.deviceRoutingSaveError': 'デバイス振り分け設定の保存に失敗しました',
  'pages.tg.deviceRoutingNoLinks': '設定可能なリンクがありません',
  'pages.tg.deviceRoutingLink': 'リンク',
  'pages.tg.deviceRoutingTagAll': '全デバイス',
  'pages.tg.deviceRoutingTagIOS': 'iOSのみ',
  'pages.tg.deviceRoutingTagAndroid': 'Androidのみ',
  'pages.tg.requestFailed': 'リクエストに失敗しました',
  'pages.tg.maxDomains': '最大 5000 件まで入力できます',
  'pages.tg.redirectType': '遷移タイプ',
  'pages.tg.urlMode': '遷移先ドメイン',
  'pages.tg.redirectTypeRequired': '遷移タイプを選択してください',
  'pages.tg.redirectTypePlaceholder': '遷移タイプを選択してください',
  'pages.tg.redirectLink': 'リンク',
  'pages.tg.redirectId': 'ID',
  'pages.tg.accessRuleRequired': 'アクセスルールを選択してください',
  'pages.tg.accessRulePlaceholder': 'アクセスルールを選択してください',
  'pages.tg.accessRuleOrder': '順次振り分け',
  'pages.tg.accessRuleRandom': 'ランダム振り分け',
  'pages.tg.domainsLabel': 'Telegram リンク',
  'pages.tg.usernameLabel': 'Telegram ID',
  'pages.tg.domainsRequired': '少なくとも 1 件の Telegram リンクを入力してください',
  'pages.tg.usernameRequired': '少なくとも 1 件の Telegram ID を入力してください',
  'pages.tg.configured': '{count} 件設定済み',
  'pages.tg.usernamePlaceholder':
    '1 行に 1 件の Telegram ID を入力してください。例: username1\\nusername2\\nusername3',
  'pages.tg.domainsPlaceholder':
    '1 行に 1 件の Telegram リンクを入力してください。例:\\nhttps://t.me/username1\\nhttps://t.me/username2',
  'pages.tg.usernameInvalid':
    'Telegram ID の形式が正しくありません（5〜32 文字の英数字、アンダースコア、先頭の+は可）: {value}',
  'pages.tg.domainsInvalid':
    'リンク形式が正しくありません。公式 Telegram ドメインのみ使用できます: {value}',

  'pages.whatsapp.title': 'WhatsAppサービス管理',
  'pages.whatsapp.subtitle':
    'WhatsApp の海外振り分けサービスを管理し、複数リンクとアクセスルール設定に対応します',
  'pages.whatsapp.addLink': 'サービスを追加',
  'pages.whatsapp.importPhone': '番号をインポート',
  'pages.whatsapp.importPhoneTitle': '番号をインポート',
  'pages.whatsapp.importPhoneConfirm': 'インポート',
  'pages.whatsapp.importPhoneUploadText': 'TXT ファイルを選択またはドロップ',
  'pages.whatsapp.importPhoneUploadHint':
    '形式: 番号 半角スペース 備考。1 行に 1 件入力してください。番号は + 付きでも使用でき、原始ファイルはローカルで解析されアップロードされません。',
  'pages.whatsapp.importPhoneFileRequired': 'TXT ファイルを選択してください',
  'pages.whatsapp.importPhoneFileTypeError': '.txt テキストファイルのみインポートできます',
  'pages.whatsapp.importPhoneFileSizeError': 'ファイルサイズは 512KB 以下にしてください',
  'pages.whatsapp.importPhoneInvalidLines':
    'インポート形式が正しくありません。行 {lines} を確認してください',
  'pages.whatsapp.importPhoneNoValidRows': '有効な電話番号が見つかりません',
  'pages.whatsapp.importPhoneTooManyRows': '一度にインポートできる番号は最大 {count} 件です',
  'pages.whatsapp.importPhoneSuccess':
    '{count} 件の番号をインポートしてサービスを作成しました。重複 {duplicate} 件はスキップしました',
  'pages.whatsapp.importPhoneError': 'インポートに失敗しました',
  'pages.whatsapp.importPhoneServiceNamePrefix': 'インポート番号',
  'pages.whatsapp.refresh': '更新',
  'pages.whatsapp.export': 'エクスポート',
  'pages.whatsapp.name': '名称',
  'pages.whatsapp.configured': '設定済み',
  'pages.whatsapp.rule': 'ルール',
  'pages.whatsapp.ruleOrder': '順序',
  'pages.whatsapp.ruleRandom': 'ランダム',
  'pages.whatsapp.rulePriority': '優先',
  'pages.whatsapp.lockIP': 'IP固定',
  'pages.whatsapp.locked': '固定済み',
  'pages.whatsapp.unlocked': '未固定',
  'pages.whatsapp.status': '状態',
  'pages.whatsapp.enabled': '有効',
  'pages.whatsapp.disabled': '無効',
  'pages.whatsapp.createdAt': '作成日時',
  'pages.whatsapp.actions': '操作',
  'pages.whatsapp.copy': 'コピー',
  'pages.whatsapp.copySuccess': 'リンクをクリップボードにコピーしました',
  'pages.whatsapp.copyError': 'コピーに失敗しました',
  'pages.whatsapp.edit': '編集',
  'pages.whatsapp.delete': '削除',
  'pages.whatsapp.deleteConfirm': 'このサービスを削除してもよろしいですか？',
  'pages.whatsapp.yes': '確認',
  'pages.whatsapp.no': 'キャンセル',
  'pages.whatsapp.addTitle': 'サービスを追加',
  'pages.whatsapp.editTitle': 'サービスを編集',
  'pages.whatsapp.serviceName': 'サービス名',
  'pages.whatsapp.quantity': '数量',
  'pages.whatsapp.serviceNamePlaceholder': 'サービス名を入力してください',
  'pages.whatsapp.serviceNameRequired': 'サービス名を入力してください',
  'pages.whatsapp.domains': '顧客リンク',
  'pages.whatsapp.domainsPlaceholder':
    '1 行に 1 件入力し、複数は改行で区切ってください',
  'pages.whatsapp.domainsRequired': '少なくとも 1 件の顧客リンクを入力してください',
  'pages.whatsapp.domainsInvalid':
    'リンク形式が正しくありません。公式 WhatsApp ドメインのみ使用できます',
  'pages.whatsapp.domainsInvalidDetailed':
    'リンク形式が正しくありません。公式 WhatsApp ドメインまたは wa.me リンクのみ使用できます: {value}',
  'pages.whatsapp.deleteAccounts': 'アカウント削除',
  'pages.whatsapp.deleteAccountsPlaceholder':
    '削除するリンク/アカウントを入力してください',
  'pages.whatsapp.deleteAccountsExtra':
    '削除するリンク/アカウントを入力してください',
  'pages.whatsapp.deleteAccountsRemoved': '{count} 件のアカウントを削除しました',
  'pages.whatsapp.configuredCount': '設定済み',
  'pages.whatsapp.configuredLinks': '件の連絡先',
  'pages.whatsapp.accessRule': 'アクセスルール',
  'pages.whatsapp.accessRulePlaceholder': 'アクセスルールを選択してください',
  'pages.whatsapp.accessRuleRequired': 'アクセスルールを選択してください',
  'pages.whatsapp.accessRuleOrder': '順序 - 順番に表示',
  'pages.whatsapp.accessRuleRandom': 'ランダム - ランダムに表示',
  'pages.whatsapp.fetchSuccess': 'サービス一覧を取得しました',
  'pages.whatsapp.fetchError': 'サービス一覧の取得に失敗しました',
  'pages.whatsapp.deleteSuccess': '削除しました',
  'pages.whatsapp.deleteError': '削除に失敗しました',
  'pages.whatsapp.updateSuccess': '更新しました',
  'pages.whatsapp.updateError': '更新に失敗しました',
  'pages.whatsapp.addSuccess': '作成しました',
  'pages.whatsapp.addError': '作成に失敗しました',
  'pages.whatsapp.exportDev': 'エクスポート機能は現在開発中です...',
  'pages.whatsapp.totalRecords': '全 {total} 件',
  'pages.whatsapp.duplicateRemoved': '{count} 件の重複項目を自動的に削除しました',
  'pages.whatsapp.unknownError': '不明なエラー',
  'pages.whatsapp.operationFailed': '操作に失敗しました',
  'pages.whatsapp.trafficDataSuccess': '振り分けデータを読み込みました',
  'pages.whatsapp.trafficDataError': '振り分けデータの読み込みに失敗しました',
  'pages.whatsapp.resetConfirmTitle': 'リセット確認',
  'pages.whatsapp.resetConfirmLine1': 'この操作は元に戻せません:',
  'pages.whatsapp.resetConfirmLine2':
    '訪問記録をクリアしてもよろしいですか？',
  'pages.whatsapp.resetButton': 'データをリセット',
  'pages.whatsapp.resetSuccess': '統計データを完全にクリアしました',
  'pages.whatsapp.dailyUV': '本日UV/昨日UV',
  'pages.whatsapp.dailyUVTooltip': '本日/昨日のユニーク訪問者数',
  'pages.whatsapp.workOrderIncrease': '本日追加/累計追加',
  'pages.whatsapp.batchLock': '一括固定',
  'pages.whatsapp.unset': '未設定',
  'pages.whatsapp.stats': 'アクセス統計',
  'pages.whatsapp.trafficData': '振り分けデータ',
  'pages.whatsapp.interceptionConfig': 'インターセプト設定',
  'pages.whatsapp.generateQr': 'QRコード生成',
  'pages.whatsapp.exportIp': 'IPエクスポート',
  'pages.whatsapp.recreateShortLink':
    '短縮リンクを生成するにはサービスを再作成してください',
  'pages.whatsapp.copyCampaignLink': '広告リンクをコピー',
  'pages.whatsapp.moreActions': 'その他の操作',
  'pages.whatsapp.shareService': 'サービスを共有',
  'pages.whatsapp.fbIOSFix': 'FB起動修正',
  'pages.whatsapp.fbIOSFixTitle': 'FB起動修正 - {name}',
  'pages.whatsapp.fbIOSFixReason':
    '一部のiPhoneユーザーがFacebookアプリ内ブラウザでWhatsAppリンクをクリックすると、外部アプリ起動がブロックされ、未インストールと表示される場合があります。',
  'pages.whatsapp.fbIOSFixScope':
    '有効にすると、iPhone + Facebookアプリ内ブラウザ + WhatsApp遷移の場合のみ中継ページを表示します。他のブラウザとAndroidは通常の遷移のままです。',
  'pages.whatsapp.fbIOSFixNotice': 'ランディングページのボタンと分流モードでは、この機能を有効にする必要はありません。',
  'pages.whatsapp.fbIOSFixEnableLabel': 'FB iOS起動修正を有効化',
  'pages.whatsapp.fbIOSFixEnableSuccess': 'FB iOS起動修正を有効にしました',
  'pages.whatsapp.fbIOSFixDisableSuccess': 'FB iOS起動修正を無効にしました',
  'pages.whatsapp.fbIOSFixUpdateError': 'FB iOS起動修正の保存に失敗しました',
  'pages.whatsapp.favorite': 'お気に入り',
  'pages.whatsapp.unfavorite': 'お気に入り解除',
  'pages.whatsapp.favoriteOnly': 'お気に入りのみ',
  'pages.whatsapp.favoriteSuccess': 'お気に入りに追加しました',
  'pages.whatsapp.unfavoriteSuccess': 'お気に入りを解除しました',
  'pages.whatsapp.favoriteToggleFailed': 'お気に入り操作に失敗しました',
  'pages.whatsapp.searchPlaceholder': '名前・コード・アカウント・リンク・備考を検索',
  'pages.whatsapp.workOrderManagement': 'ワークオーダー管理',
  'pages.whatsapp.viewAll': 'すべて表示',
  'pages.whatsapp.workOrderOnly': 'ワークオーダーのみ',
  'pages.whatsapp.batchDedupe': '一括重複排除',
  'pages.whatsapp.myIpLibrary': 'マイIPライブラリ',
  'pages.whatsapp.lockIPTooltip':
    '有効にすると、ブラウザフィンガープリントと IP の重複排除により、同じ訪問者には 1 つの振り分け先のみ表示されます',
  'pages.whatsapp.trafficStatsTitle': '振り分けデータ統計 - {name}',
  'pages.whatsapp.close': '閉じる',
  'pages.whatsapp.refreshData': 'データを更新',
  'pages.whatsapp.showingRecords': '{total} 件中 {filtered} 件を表示',
  'pages.whatsapp.customerLink': '顧客リンク',
  'pages.whatsapp.workOrderIds': '紐付け',
  'pages.whatsapp.percentage': '割合%',
  'pages.whatsapp.disabledManual': '無効（手動）',
  'pages.whatsapp.disabledFlowOptimize': '無効（フロー最適化）',
  'pages.whatsapp.disabledAuto': '無効（自動）',
  'pages.whatsapp.disabledManualTooltip':
    '手動で無効化したアカウントは、同期時に自動で再有効化されません',
  'pages.whatsapp.disabledFlowOptimizeTooltip':
    '本日のワークオーダーしきい値到達後にフロー最適化で無効化され、手動でのみ再有効化できます',
  'pages.whatsapp.disabledAutoTooltip':
    '自動ルールによって無効化され、手動で再有効化できます',
  'pages.whatsapp.remarkTitle': '備考を設定',
  'pages.whatsapp.remarkPlaceholder': '備考を入力してください',
  'pages.whatsapp.remarkSuccess': '備考を更新しました',
  'pages.whatsapp.setRemark': '備考を設定',
  'pages.whatsapp.pageRange': '{start}-{end} / {total}',
  'pages.whatsapp.exportSuccess': 'エクスポートしました',
  'pages.whatsapp.batchLockTitle': '一括IP固定設定',
  'pages.whatsapp.batchLockDesc':
    '同じ IP 重複排除グループを共有するサービスを選択してください',
  'pages.whatsapp.batchLockPlaceholder': 'グループ名を入力してください（必須）',
  'pages.whatsapp.batchLockConfirm': '確認',
  'pages.whatsapp.selectedServices': '{count} 件のサービスを選択済み',
  'pages.whatsapp.batchDedupeRequired':
    '重複排除するには少なくとも 2 件のサービスを選択してください',
  'pages.whatsapp.batchDedupeSuccess':
    '{count} 件のサービスを同じ重複排除グループに割り当てました',
  'pages.whatsapp.batchDedupeError': '設定の更新に失敗しました',
  'pages.whatsapp.unbindBatchLockConfirmTitle':
    '現在の重複排除グループとの紐付けを解除しますか？',
  'pages.whatsapp.unbindBatchLockConfirmDesc':
    '解除後、このサービスはこの一括重複排除グループに属さなくなります。',
  'pages.whatsapp.unbindBatchLockConfirmOk': '解除',
  'pages.whatsapp.unbindBatchLockSuccess':
    '一括重複排除の紐付けを解除しました',
  'pages.whatsapp.deviceRouting': 'デバイス振り分け',
  'pages.whatsapp.deviceRoutingTitle': 'デバイス振り分け設定 - {name}',
  'pages.whatsapp.deviceRoutingSave': '保存',
  'pages.whatsapp.deviceRoutingSaveSuccess': 'デバイス振り分け設定を保存しました',
  'pages.whatsapp.deviceRoutingSaveError': 'デバイス振り分け設定の保存に失敗しました',
  'pages.whatsapp.deviceRoutingNoLinks': '設定可能なリンクがありません',
  'pages.whatsapp.deviceRoutingLink': 'リンク',
  'pages.whatsapp.deviceRoutingTagAll': '全デバイス',
  'pages.whatsapp.deviceRoutingTagIOS': 'iOSのみ',
  'pages.whatsapp.deviceRoutingTagAndroid': 'Androidのみ',
  'pages.whatsapp.domainOrPhoneRequired':
    '少なくとも 1 件の電話番号または顧客リンクを入力してください',
  'pages.whatsapp.phoneLabel': '電話番号',
  'pages.whatsapp.phoneHint':
    '国番号を含め、プラス記号なしで入力してください',
  'pages.whatsapp.phoneRequired': '少なくとも 1 件の電話番号を入力してください',
  'pages.whatsapp.phoneInvalid':
    '電話番号の形式が正しくありません。数字のみ使用できます: {value}',
  'pages.whatsapp.redirectType': '遷移タイプ',
  'pages.whatsapp.redirectTypeRequired': '遷移タイプを選択してください',
  'pages.whatsapp.redirectTypePlaceholder':
    '遷移タイプを選択してください',
  'pages.whatsapp.redirectPhone': '電話番号',
  'pages.whatsapp.redirectLink': 'リンク遷移',
  'pages.whatsapp.greetingMode': '挨拶文モード',
  'pages.whatsapp.greetingModeSingle': '単一挨拶文',
  'pages.whatsapp.greetingModeBatch': '一括挨拶文',
  'pages.whatsapp.singleGreetingLabel': '単一挨拶文',
  'pages.whatsapp.singleGreetingExtra':
    'この挨拶文は WhatsApp メッセージに自動で追加されます',
  'pages.whatsapp.singleGreetingPlaceholder':
    '例: こんにちは、サービスについて相談したいです。',
  'pages.whatsapp.batchGreetingLabel': '一括挨拶文',
  'pages.whatsapp.batchGreetingLimit': '最大 {max} 件まで。空行は数えません。',
  'pages.whatsapp.batchGreetingCount': '{count} / {max} 件',
  'pages.diversion.greetingLineLimit': '最大 {max} 行まで。空行は数えません。',
  'pages.diversion.greetingLineCount': '{count} / {max} 行',
  'pages.whatsapp.batchGreetingExtra':
    '1 行に 1 件入力すると、システムが自動で順番に切り替えます',
  'pages.whatsapp.batchGreetingPlaceholder':
    'こんにちは、サービスについて相談したいです。\\nどのようなサポートが可能ですか？\\nお気軽にお問い合わせください！',
  'pages.whatsapp.submitUpdate': '更新',
  'pages.whatsapp.submitCreate': '作成',
  'pages.whatsapp.cancel': 'キャンセル',
  'pages.whatsapp.enableSuccess': '有効にしました',
  'pages.whatsapp.disableSuccess': '無効にしました',
  'pages.whatsapp.updateLinkTitle': 'リンク内容を編集',
  'pages.whatsapp.linkOrPhone': 'リンクまたは電話番号',
  'pages.whatsapp.linkEmpty': 'リンクまたは電話番号は空にできません',
  'pages.whatsapp.newLinkPlaceholder': '新しいリンクまたは電話番号を入力してください',
  'pages.whatsapp.priorityRouting': '優先振り分け',
  'pages.whatsapp.thresholdLabel': 'UVしきい値',
  'pages.whatsapp.thresholdTooltip':
    'しきい値はユニーク訪問者数に基づき、5%〜20% 程度の変動が発生する場合があります。',
  'pages.whatsapp.thresholdRequired': 'UVしきい値を入力してください',
  'pages.whatsapp.thresholdRange': 'しきい値は 1〜10000 の範囲で入力してください',
  'pages.whatsapp.linkUpdateFailed': 'リンクの更新に失敗しました',
  'pages.whatsapp.editSuccess': '編集しました',

  'pages.custom.title': 'カスタム振り分け管理',
  'pages.custom.subtitle':
    'カスタムドメイン振り分けサービスを管理し、複数リンクとアクセスルール設定に対応します',
  'pages.custom.addService': 'サービスを追加',
  'pages.custom.refresh': '更新',
  'pages.custom.interceptionConfig': 'インターセプト設定',
  'pages.custom.batchDedupe': '一括重複排除',
  'pages.custom.searchPlaceholder': 'サービス名を検索',
  'pages.custom.totalRecords': '全 {total} 件',
  'pages.custom.addTitle': 'サービスを追加',
  'pages.custom.editTitle': 'サービスを編集',
  'pages.custom.serviceName': 'サービス名',
  'pages.custom.serviceNamePlaceholder': 'サービス名を入力してください',
  'pages.custom.serviceNameRequired': 'サービス名を入力してください',
  'pages.custom.serviceDescription': 'サービス説明',
  'pages.custom.serviceDescriptionPlaceholder': 'サービス説明を入力してください',
  'pages.custom.links': 'リンク',
  'pages.custom.linksExtra':
    '1 行に 1 件入力し、複数は改行で区切ってください。https:// で始める必要があります',
  'pages.custom.domainsRequired': '少なくとも 1 件のリンクを入力してください',
  'pages.custom.domainsInvalid':
    'リンク形式が正しくありません。https:// で始めてください: {value}',
  'pages.custom.accessRule': 'アクセスルール',
  'pages.custom.accessRulePlaceholder': 'アクセスルールを選択してください',
  'pages.custom.accessRuleRequired': 'アクセスルールを選択してください',
  'pages.custom.accessRuleOrder': '順序 - 順番に表示',
  'pages.custom.accessRuleRandom': 'ランダム - ランダムに表示',
  'pages.custom.statusSettings': '状態設定',
  'pages.custom.lockIP': 'IP固定',
  'pages.custom.lockIPTooltip':
    '有効にすると、ブラウザフィンガープリントと IP の重複排除により、同じ訪問者には 1 つの振り分け先のみ表示されます',
  'pages.custom.status': '状態',
  'pages.custom.enabled': '有効',
  'pages.custom.disabled': '無効',
  'pages.custom.submitUpdate': '更新',
  'pages.custom.submitCreate': '作成',
  'pages.custom.cancel': 'キャンセル',
  'pages.custom.loadError': 'データの読み込みに失敗しました',
  'pages.custom.requestFailed': 'リクエストに失敗しました',
  'pages.custom.updateSuccess': '更新しました',
  'pages.custom.addSuccess': '作成しました',
  'pages.custom.updateError': '更新に失敗しました',
  'pages.custom.operationFailed': '操作に失敗しました',
  'pages.custom.deleteSuccess': '削除しました',
  'pages.custom.deleteError': '削除に失敗しました',
  'pages.custom.shortCodeMissing':
    '短縮コードが存在しません。サービスを再作成してください',
  'pages.custom.copySuccess': '短縮リンクをクリップボードにコピーしました',
  'pages.custom.copyError': 'コピーに失敗しました',
  'pages.custom.trafficDataError': '振り分けデータの取得に失敗しました',
  'pages.custom.enableSuccess': '有効にしました',
  'pages.custom.disableSuccess': '無効にしました',
  'pages.custom.remarkTitle': '備考を設定',
  'pages.custom.remarkPlaceholder': '備考を入力してください',
  'pages.custom.remarkSuccess': '備考を更新しました',
  'pages.custom.updateLinkTitle': 'リンク内容を編集',
  'pages.custom.currentContent': '現在の内容',
  'pages.custom.newLinkPlaceholder': '新しいリンクを入力してください',
  'pages.custom.linkEmpty': 'リンクは空にできません',
  'pages.custom.linkUpdateSuccess': 'リンク内容を更新しました',
  'pages.custom.unknownError': '不明なエラー',
  'pages.custom.resetConfirmTitle': 'リセット確認',
  'pages.custom.resetConfirmContent':
    'リセットすると、すべての顧客リンクの本日 UV / PV データが削除されます。この操作は元に戻せません。続行しますか？',
  'pages.custom.resetButton': 'リセットを確認',
  'pages.custom.resetSuccess': '統計データをリセットしました',
  'pages.custom.name': '名称',
  'pages.custom.quantity': '数量',
  'pages.custom.description': '説明',
  'pages.custom.configured': '設定済み',
  'pages.custom.configuredLinks': '{count} 件のリンク',
  'pages.custom.rule': 'ルール',
  'pages.custom.ruleOrder': '順序',
  'pages.custom.ruleRandom': 'ランダム',
  'pages.custom.locked': '固定済み',
  'pages.custom.unlocked': '未固定',
  'pages.custom.batchLock': '一括固定',
  'pages.custom.unset': '未設定',
  'pages.custom.createdAt': '作成日時',
  'pages.custom.actions': '操作',
  'pages.custom.stats': 'アクセス統計',
  'pages.custom.trafficData': '振り分けデータ',
  'pages.custom.generateQr': 'QRコード生成',
  'pages.custom.edit': '編集',
  'pages.custom.delete': '削除',
  'pages.custom.deleteConfirm': '削除確認',
  'pages.custom.deleteConfirmContent':
    'このサービスを削除してもよろしいですか？',
  'pages.custom.yes': '確認',
  'pages.custom.recreateShortLink':
    '短縮リンクを生成するにはサービスを再作成してください',
  'pages.custom.copyCampaignLink': '広告リンクをコピー',
  'pages.custom.moreActions': 'その他の操作',
  'pages.custom.shareService': 'サービスを共有',
  'pages.custom.trafficStatsTitle': '振り分けデータ統計 - {name}',
  'pages.custom.close': '閉じる',
  'pages.custom.refreshData': 'データを更新',
  'pages.custom.customerLink': '顧客リンク',
  'pages.custom.percentage': '割合%',
  'pages.custom.setRemark': '備考を設定',
  'pages.custom.pageRange': '{start}-{end} / {total}',
  'pages.custom.batchLockTitle': '一括IP固定設定',
  'pages.custom.batchLockDesc':
    '同じ IP 重複排除グループを共有するサービスを選択してください',
  'pages.custom.batchLockPlaceholder': 'グループ名を入力してください（必須）',
  'pages.custom.selectedServices': '{count} 件のサービスを選択済み',
  'pages.custom.batchDedupeRequired':
    '少なくとも 1 件のサービスを選択してください',
  'pages.custom.batchDedupeSuccess':
    '{count} 件のサービスを更新しました',

  'pages.serviceManagement.title': 'サービス管理',
  'pages.serviceManagement.subtitle':
    'すべてのプラットフォームの振り分けデータを一か所で確認・管理できます',
  'pages.serviceManagement.platformCustom': 'カスタム振り分け',
  'pages.serviceManagement.custom': 'カスタム',
  'pages.serviceManagement.selectPlatform': 'プラットフォームを選択',
  'pages.serviceManagement.selectPlatformPlaceholder':
    'プラットフォームを選択してください',
  'pages.serviceManagement.selectService': 'サービスを選択',
  'pages.serviceManagement.selectServicePlaceholder':
    '先にプラットフォームを選択してください',
  'pages.serviceManagement.actions': '操作',
  'pages.serviceManagement.refresh': '更新',
  'pages.serviceManagement.autoRefresh': '自動更新',
  'pages.serviceManagement.autoRefreshEnabled':
    '{interval}ごとに自動更新を有効にしました',
  'pages.serviceManagement.autoRefreshSeconds': '{seconds} 秒',
  'pages.serviceManagement.autoRefreshMinutes': '{minutes} 分',
  'pages.serviceManagement.stopAutoRefresh': '自動更新を停止',
  'pages.serviceManagement.autoRefreshStopped': '自動更新を停止しました',
  'pages.serviceManagement.resetStats': '統計をリセット',
  'pages.serviceManagement.noServices':
    'このプラットフォームには利用可能なサービスがありません',
  'pages.serviceManagement.loadServicesError':
    'サービス一覧の読み込みに失敗しました',
  'pages.serviceManagement.loadDataSuccess': 'データを読み込みました',
  'pages.serviceManagement.loadDataError': 'データの読み込みに失敗しました',
  'pages.serviceManagement.resetConfirmTitle': 'リセット確認',
  'pages.serviceManagement.resetConfirmContent':
    'リセットすると、すべての顧客リンクの本日 UV / PV データが削除されます。この操作は元に戻せません。続行しますか？',
  'pages.serviceManagement.resetButton': 'リセットを確認',
  'pages.serviceManagement.resetSuccess': '統計データをリセットしました',
  'pages.serviceManagement.cancel': 'キャンセル',
  'pages.serviceManagement.confirm': '確認',
  'pages.serviceManagement.unbind': '紐付け解除',
  'pages.serviceManagement.unbindConfirmTitle': '紐付け解除の確認',
  'pages.serviceManagement.unbindConfirmContent':
    'ワークオーダー「{name}」を現在のサービスから解除してもよろしいですか？',
  'pages.serviceManagement.unbindSuccess': '解除しました',
  'pages.serviceManagement.unbindFailed': '解除に失敗しました',
  'pages.serviceManagement.updateError': '更新に失敗しました',
  'pages.serviceManagement.unknownError': '不明なエラー',
  'pages.serviceManagement.enableSuccess': '有効にしました',
  'pages.serviceManagement.disableSuccess': '無効にしました',
  'pages.serviceManagement.operationFailed': '操作に失敗しました',
  'pages.serviceManagement.priorityUpdateSuccess':
    '優先設定を更新しました',
  'pages.serviceManagement.thresholdUpdateFailed':
    'しきい値の更新に失敗しました',
  'pages.serviceManagement.remarkTitle': '備考を設定',
  'pages.serviceManagement.remarkPlaceholder': '備考を入力してください',
  'pages.serviceManagement.remarkSuccess': '備考を更新しました',
  'pages.serviceManagement.setTargetTitle': '目標値を設定',
  'pages.serviceManagement.targetPlaceholder':
    '目標値を入力してください（0 は未設定）',
  'pages.serviceManagement.targetHint':
    '注: この設定の有効期間は 24 時間です。期限切れ後は再設定が必要です。',
  'pages.serviceManagement.targetSuccess': '目標値を更新しました',
  'pages.serviceManagement.updateLinkTitle': 'リンク内容を編集',
  'pages.serviceManagement.currentContent': '現在の内容',
  'pages.serviceManagement.newLinkPlaceholder': '新しいリンクまたは ID を入力してください',
  'pages.serviceManagement.linkEmpty': 'リンクまたは ID は空にできません',
  'pages.serviceManagement.linkUpdateSuccess':
    'リンク内容を更新しました',
  'pages.serviceManagement.boundWorkOrders': '紐付け済みワークオーダー',
  'pages.serviceManagement.trafficData': '振り分けデータ',
  'pages.serviceManagement.searchAccount': 'アカウントを検索',
  'pages.serviceManagement.totalUV': '総 UV',
  'pages.serviceManagement.totalPV': '総 PV',
  'pages.serviceManagement.linksCount': 'リンク数',
  'pages.serviceManagement.avgUV': '平均 UV',
  'pages.serviceManagement.target': '目標値',
  'pages.serviceManagement.todayIncrease': '本日追加',
  'pages.serviceManagement.totalIncrease': '累計追加',
  'pages.serviceManagement.workOrderStats': 'ワークオーダー統計',
  'pages.serviceManagement.emptyTitle':
    '先にプラットフォームとサービスを選択してください',
  'pages.serviceManagement.emptySubtitle':
    '選択後、このサービスの振り分けデータと統計がここに表示されます',
  'pages.serviceManagement.customerLink': '顧客リンク',
  'pages.serviceManagement.priority': '優先度',
  'pages.serviceManagement.priorityHigh': '優先',
  'pages.serviceManagement.priorityNormal': '通常',
  'pages.serviceManagement.thresholdShort': 'UVしきい値',
  'pages.serviceManagement.priorityProgress': '優先進捗',
  'pages.serviceManagement.percentage': '割合%',
  'pages.serviceManagement.status': '状態',
  'pages.serviceManagement.enabled': '有効',
  'pages.serviceManagement.disabled': '無効',
  'pages.serviceManagement.disabledManual': '無効（手動）',
  'pages.serviceManagement.disabledFlowOptimize':
    '無効（フロー最適化）',
  'pages.serviceManagement.disabledAuto': '無効（自動）',
  'pages.serviceManagement.disabledManualTooltip':
    '手動で無効化したアカウントは、同期時に自動で再有効化されません',
  'pages.serviceManagement.disabledFlowOptimizeTooltip':
    '本日のワークオーダーしきい値到達後にフロー最適化で無効化され、手動でのみ再有効化できます',
  'pages.serviceManagement.disabledAutoTooltip':
    '自動ルールによって無効化され、手動で再有効化できます',
  'pages.serviceManagement.remark': '備考',
  'pages.serviceManagement.setRemark': '備考を設定',
  'pages.serviceManagement.edit': '編集',
  'pages.serviceManagement.receptionSettings': '受付設定',
  'pages.serviceManagement.receptionLimit': '受付件数上限',
  'pages.serviceManagement.receptionUnlimited': '無制限',
  'pages.serviceManagement.receptionCurrentTotal': 'ワークオーダー累計受付数',
  'pages.serviceManagement.receptionLimitHint':
    '紐付けたワークオーダーの累計受付数が上限に達すると、アカウントを自動で無効化します。保存しても件数はリセットされません。0 は無制限です。すでに上限に達している場合は、保存時に無効化されます。',
  'pages.serviceManagement.receptionEnableHint':
    '上限を増やす、または解除しても自動では有効になりません。手動で有効にしてください。',
  'pages.serviceManagement.receptionNoWorkOrder':
    'このアカウントにはワークオーダーが紐付けられていません。先に設定を保存でき、紐付けと同期の後に適用されます。',
  'pages.serviceManagement.receptionLimitInvalid': '0 から 2147483647 の整数を入力してください',
  'pages.serviceManagement.receptionLimitBelowCurrentTotal': '設定した件数が累計受付数を下回っています！',
  'pages.serviceManagement.receptionSave': '保存',
  'pages.serviceManagement.receptionSaveSuccess': '受付設定を保存しました',
  'pages.serviceManagement.receptionLoadError': '受付設定の読み込みに失敗しました',
  'pages.serviceManagement.disabledReception': '受付上限到達',
  'pages.serviceManagement.disabledReceptionTooltip':
    'ワークオーダーの累計受付数が上限に達したため、自動で無効化されました。上限を増やすか解除した後、手動で有効にできます。',
  'pages.serviceManagement.pageRange': '{start}-{end} / {total}',
  'pages.serviceManagement.workOrderLoadError':
    'ワークオーダー一覧の読み込みに失敗しました',
  'pages.serviceManagement.workOrderStatusActive': '稼働中',
  'pages.serviceManagement.workOrderStatusPaused': '一時停止',
  'pages.serviceManagement.workOrderStatusError': 'エラー',
  'pages.serviceManagement.workOrderName': 'ワークオーダー名',
  'pages.serviceManagement.platformType': 'プラットフォーム種別',
  'pages.serviceManagement.workOrderPlatform': 'ワークオーダープラットフォーム',
  'pages.serviceManagement.totalAccounts': '総アカウント数',
  'pages.serviceManagement.availableCount': '利用可能',
  'pages.serviceManagement.unavailableCount': '利用不可',
  'pages.serviceManagement.lastUpdatedAt': '最終更新',
  'pages.serviceManagement.workOrderStatus': 'ワークオーダー状態',
  'pages.serviceManagement.noBoundWorkOrders':
    '紐付けられたワークオーダーはありません',
  'pages.serviceManagement.totalRecords': '全 {total} 件',

  'pages.stats.loadSuccess': 'データを読み込みました',
  'pages.stats.loadError': 'データの読み込みに失敗しました',
  'pages.stats.date': '日付',
  'pages.stats.visitTime': '訪問時刻',
  'pages.stats.customerLink': '顧客リンク',
  'pages.stats.region': '地域',
  'pages.stats.device': 'デバイス',
  'pages.stats.system': 'システム',
  'pages.stats.model': '機種',
  'pages.stats.visitStats': 'アクセス統計',
  'pages.stats.today': '今日',
  'pages.stats.sevenDays': '7日間',
  'pages.stats.refresh': '更新',
  'pages.stats.refreshData': 'データを更新',
  'pages.stats.close': '閉じる',
  'pages.stats.syncLoading': '同期してデータを読み込み中...',
  'pages.stats.pageRange': '{start}-{end} / {total}',
  'pages.stats.linkSummary': 'リンク概要',
  'pages.stats.unknown': '不明',
  'pages.stats.mobile': 'モバイル',
  'pages.stats.desktop': 'デスクトップ',
  'pages.stats.tablet': 'タブレット',

  'pages.domainCopy.copy': 'コピー',
  'pages.domainCopy.copySuccess': 'コピーしました',
  'pages.domainCopy.copyFailed': 'コピーに失敗しました',
  'pages.domainCopy.publicDomain': '共用ドメイン',
  'pages.domainCopy.customDomain': 'カスタムドメイン',
  'pages.domainCopy.remark': '備考',
  'pages.domainCopy.sslSuccess': 'SSL 有効',
  'pages.domainCopy.sslPending': '処理中',
  'pages.domainCopy.sslFailed': 'SSL 失敗',

  'pages.interception.title': 'インターセプト設定 - {name}',
  'pages.interception.countryControl': '国別制御',
  'pages.interception.countryControlExtra':
    '有効にすると、選択した国の IP のみアクセスできます。その他の国からの IP はブロックされます。',
  'pages.interception.blockAll': 'すべてブロック',
  'pages.interception.blockAllExtra':
    '有効にすると、すべての訪問者をインターセプト表示 URL に従って処理します。TikTok インスタントページや広告審査中に一時的に審査ページへ送る用途に使えます。',
  'pages.interception.shareRefererBlock': '共有リンクをブロック',
  'pages.interception.shareRefererBlockExtra':
    'Referer が android-app:// で始まる Android アプリからのアクセスをブロックします。',
  'pages.interception.enabled': '有効',
  'pages.interception.disabled': '無効',
  'pages.interception.allowedCountries': '許可国',
  'pages.interception.allowedCountriesRequired':
    '少なくとも 1 つの国を選択してください',
  'pages.interception.allowedCountriesPlaceholder':
    '許可する国を選択してください',
  'pages.interception.countryBlock': '国をブロック',
  'pages.interception.countryBlockExtra':
    '選択した国の IP をブロックします。許可国が有効な場合は許可ルールが優先され、このルールは実行されません。',
  'pages.interception.blockedCountries': 'ブロックする国',
  'pages.interception.blockedCountriesRequired':
    'ブロックする国を少なくとも 1 つ選択してください',
  'pages.interception.blockedCountriesPlaceholder':
    'ブロックする国を選択してください',
  'pages.interception.chineseDetection': '中国語検出',
  'pages.interception.chineseDetectionExtra':
    '訪問者ブラウザの言語を検出し、中国語かどうかでアクセスを制御します',
  'pages.interception.chineseDetectionMode': '中国語検出モード',
  'pages.interception.chineseDetectionModeRequired':
    '検出モードを選択してください',
  'pages.interception.blockChinese': '中国語ブラウザをブロック',
  'pages.interception.onlyAllowChinese': '中国語ブラウザのみ許可',
  'pages.interception.displayUrl': 'インターセプト表示 URL',
  'pages.interception.displayUrlExtra':
    'インターセプト時にこの URL へリダイレクトします。空欄の場合は 404 を返します。',
  'pages.interception.displayUrlPlaceholder': 'https://example.com',
  'pages.interception.updateSuccess': '更新しました',
  'pages.interception.saveSuccess': '保存しました',
  'pages.interception.operationFailed': '操作に失敗しました',
  'pages.interception.linkedIpLibrary': '連携 IP ライブラリ: {name}',

  'pages.exportIP.title': 'IPエクスポート',
  'pages.exportIP.confirm': '確認',
  'pages.exportIP.cancel': 'キャンセル',
  'pages.exportIP.exporting': 'エクスポート中です。しばらくお待ちください...',
  'pages.exportIP.infoMessage':
    'この機能では、ランディングページ経由で収集した訪問者 IP データをエクスポートします',
  'pages.exportIP.timeRange': '時間範囲',
  'pages.exportIP.timeRangeRequired': '時間範囲を選択してください',
  'pages.exportIP.today': '今日',
  'pages.exportIP.last7Days': '直近 7 日間',
  'pages.exportIP.exportType': 'エクスポート方法',
  'pages.exportIP.exportText': 'テキストにエクスポート',
  'pages.exportIP.exportLibrary': 'マイ IP ライブラリにエクスポート',
  'pages.exportIP.action': '処理方法',
  'pages.exportIP.actionNew': '新規追加（ライブラリ作成）',
  'pages.exportIP.actionMerge': '既存ライブラリに統合',
  'pages.exportIP.countryRemark': '国別備考',
  'pages.exportIP.countryRemarkRequired': '国別備考を入力してください',
  'pages.exportIP.countryRemarkPlaceholder': '例: 日本、アメリカ',
  'pages.exportIP.industryRemark': '業種備考',
  'pages.exportIP.industryRemarkRequired': '業種備考を入力してください',
  'pages.exportIP.industryRemarkPlaceholder': '例: EC、金融',
  'pages.exportIP.selectLibrary': 'IP ライブラリを選択',
  'pages.exportIP.selectLibraryRequired':
    'IP ライブラリを選択してください',
  'pages.exportIP.selectLibraryPlaceholder':
    '統合先の IP ライブラリを選択してください',
  'pages.exportIP.libraryOption': '{country} - {industry} ({count} 件の IP)',
  'pages.exportIP.largeDataTitle': '大量データ',
  'pages.exportIP.largeDataContent':
    '{count} 件の IP をエクスポートしようとしています。時間がかかる場合があります。続行しますか？',
  'pages.exportIP.continueExport': 'エクスポートを続行',
  'pages.exportIP.successText': 'エクスポートしました。合計 {count} 件の IP',
  'pages.exportIP.successLibrary':
    'IP ライブラリへエクスポートしました。合計 {count} 件の IP',
  'pages.exportIP.failed': 'エクスポートに失敗しました',

  'pages.workOrder.requestFailedRetry':
    'リクエストに失敗しました。再試行してください',
  'pages.workOrder.unknownError': '不明なエラーが発生しました',
  'pages.workOrder.loadOrdersFailed': 'ワークオーダーの読み込みに失敗しました',
  'pages.workOrder.updateSuccess': 'ワークオーダーを更新しました',
  'pages.workOrder.createSuccess': 'ワークオーダーを作成しました',
  'pages.workOrder.operationFailed': '操作に失敗しました',
  'pages.workOrder.deleteConfirmTitle': '削除確認',
  'pages.workOrder.deleteConfirmContent':
    'このワークオーダーを削除してもよろしいですか？この操作は元に戻せません。',
  'pages.workOrder.confirm': '確認',
  'pages.workOrder.cancel': 'キャンセル',
  'pages.workOrder.deleteSuccess': '削除しました',
  'pages.workOrder.deleteFailed': '削除に失敗しました',
  'pages.workOrder.fetchSuccessBase':
    '取得成功! 総アカウント数: {total}、正常: {normal}、異常: {abnormal}',
  'pages.workOrder.fetchSuccessPages': '、{pages} ページを読み込みました',
  'pages.workOrder.fetchSuccessSample':
    '；サンプル [電話番号: {phone} 状態: {status} 友達/グループ: {friend} 本日追加: {daily}]',
  'pages.workOrder.fetchFailed': '取得に失敗しました',
  'pages.workOrder.resumeSuccess':
    'ワークオーダーを再開し、失敗回数をリセットしました',
  'pages.workOrder.resumeFailed': '再開に失敗しました',
  'pages.workOrder.pauseSuccess': 'ワークオーダーを一時停止しました',
  'pages.workOrder.pauseFailed': '一時停止に失敗しました',
  'pages.workOrder.platformParamInvalidFetchServices':
    'プラットフォーム引数が不足または無効なため、サービス一覧を読み込めません',
  'pages.workOrder.loadServicesWarning':
    '現在のプラットフォームに利用可能なサービスがありません。先にサービスを作成してください。',
  'pages.workOrder.loadServicesFailed': 'サービス一覧の読み込みに失敗しました',
  'pages.workOrder.platformInvalidImport':
    'ワークオーダーのプラットフォーム情報が不足または無効なため、インポートできません',
  'pages.workOrder.selectImportService':
    'インポート先のサービスを選択してください',
  'pages.workOrder.importSuccessNew':
    'インポート成功! サービスを作成しました。振り分けページを更新して確認してください。',
  'pages.workOrder.importSuccessReplace':
    'インポート成功! 既存サービス内のアカウントを置換しました。',
  'pages.workOrder.importSuccessMerge':
    'インポート成功! 既存サービスにアカウントをマージしました。',
  'pages.workOrder.importFailed': 'インポートに失敗しました',
  'pages.workOrder.platformMissingLoadServices':
    'プラットフォーム情報が不足しているため、サービス一覧を読み込めません',
  'pages.workOrder.loadCaptchaFailed': '認証コードの読み込みに失敗しました',
  'pages.workOrder.sessionExpired':
    'ログインセッションの有効期限が切れました。認証コードを更新して再試行してください。',
  'pages.workOrder.loginBindSuccess': 'ログイン連携に成功しました',
  'pages.workOrder.loginFailed': 'ログインに失敗しました',
  'pages.workOrder.name': 'ワークオーダー名',
  'pages.workOrder.platformType': 'プラットフォーム種別',
  'pages.workOrder.orderPlatform': 'ワークオーダープラットフォーム',
  'pages.workOrder.accountCount': 'アカウント数',
  'pages.workOrder.todayIncrease': '本日追加',
  'pages.workOrder.totalIncrease': '累計追加',
  'pages.workOrder.lastFetch': '最終取得',
  'pages.workOrder.orderStatus': 'ワークオーダー状態',
  'pages.workOrder.actions': '操作',
  'pages.workOrder.edit': '編集',
  'pages.workOrder.pause': '一時停止',
  'pages.workOrder.resume': '再開',
  'pages.workOrder.delete': '削除',
  'pages.workOrder.resumeRunning': '再開',
  'pages.workOrder.read': '取得',
  'pages.workOrder.import': 'インポート',
  'pages.workOrder.rebindLogin': '再ログイン連携',
  'pages.workOrder.loginBind': 'ログイン連携',
  'pages.workOrder.more': 'その他',
  'pages.workOrder.title': 'ワークオーダー管理',
  'pages.workOrder.newOrder': '新規ワークオーダー',
  'pages.workOrder.batchCreate': '一括追加',
  'pages.workOrder.totalRecords': '全 {total} 件',
  'pages.workOrder.editTitle': 'ワークオーダー編集',
  'pages.workOrder.createTitle': '新規ワークオーダー',
  'pages.workOrder.platformTypeRequired':
    'プラットフォーム種別を選択してください',
  'pages.workOrder.orderPlatformRequired':
    'ワークオーダープラットフォームを選択してください',
  'pages.workOrder.whatshubShortUrlNotice':
    'WhatsHub の完全なワークオーダー URL（/work-order-sharing、sid と workId が必要）、/m/ 共有リンク、または API リンクを入力してください。/m/ 共有リンクを使用する場合は共有パスワードも入力してください。',
  'pages.workOrder.whatshubShortUrlInvalid':
    'アドレスが正しくありません。WhatsHub の完全なワークオーダー URL（/work-order-sharing、sid と workId が必要）、/m/ 共有リンク、または API リンクを入力してください。',
  'pages.workOrder.nameRequired': 'ワークオーダー名を入力してください',
  'pages.workOrder.namePlaceholder': 'ワークオーダー名を入力してください',
  'pages.workOrder.link': 'ワークオーダーURL',
  'pages.workOrder.linkRequired': 'ワークオーダーURLを入力してください',
  'pages.workOrder.cloudLinkInvalid':
    'クラウド制御 URL には /share/share/index.html?token=xxx を含める必要があります',
  'pages.workOrder.linkPlaceholderDefault':
    'http://47.76.114.187:61932/share/share/index.html?token=...',
  'pages.workOrder.linkPlaceholder007':
    '007 プラットフォームの共有 URL を入力してください。形式は任意です',
  'pages.workOrder.linkPlaceholderSihai':
    '四海营销のログイン URL を入力してください（デフォルト: https://v2sotua1.7xing168.com/agent/login.html）',
  'pages.workOrder.password': 'パスワード',
  'pages.workOrder.passwordPlaceholder007':
    '任意入力。入力すると 007 ワークオーダーのログインに使用されます。',
  'pages.workOrder.passwordPlaceholderScrmChampion':
    '任意入力。入力すると SCRM Champion ワークオーダーのログインに使用されます。',
  'pages.workOrder.passwordPlaceholderSalesmartly':
    '任意入力。入力すると SaleSmartly ワークオーダーのログインに使用されます。',
  'pages.workOrder.passwordPlaceholderHaiwang':
    '任意入力。入力すると Haiwang ワークオーダーのログインに使用されます。',
  'pages.workOrder.passwordPlaceholderCeoscrm':
    '任意入力。入力すると CEOSCRM ワークオーダーのログインに使用されます。',
  'pages.workOrder.passwordPlaceholderUrl66':
    '任意入力。入力すると Rocket url66 ワークオーダーのログインに使用されます。',
  'pages.workOrder.passwordPlaceholderQukazhen':
    '任意入力。入力すると Qukazhen ワークオーダーのログインに使用されます。',
  'pages.workOrder.passwordPlaceholderChatknow':
    '任意入力。入力すると Chatknow ワークオーダーのログインに使用されます。',
  'pages.workOrder.passwordPlaceholderWachat':
    '任意入力。入力すると WAchat ワークオーダーのログインに使用されます。',
  'pages.workOrder.passwordPlaceholderXinghe':
    '任意入力。入力すると Xinghe Cloud Control ワークオーダーのログインに使用されます。',
  'pages.workOrder.passwordPlaceholderA2c':
    'API リンクに password が含まれる場合は省略可能。ここに入力したパスワードが優先されます。',
  'pages.workOrder.a2cUrlNotice':
    'A2C の共有リンク（id）または共有一覧 API リンク（shareCode）に対応。API リンクには password を指定できます。短縮 URL は先にブラウザで開いてください。',
  'pages.workOrder.passwordPlaceholderUrl99':
    '任意入力。入力すると Rocket ワークオーダーのログインに使用されます。',
  'pages.workOrder.advancedSettings': '詳細設定',
  'pages.common.expandSettings': '設定を開く',
  'pages.common.collapseSettings': '設定を閉じる',
  'pages.workOrder.autoDisable':
    '自動無効化（異常アカウントを自動で除外し、無駄なトラフィックを減らします）',
  'pages.workOrder.autoOptimize':
    '自動最適化（トラフィックはあるが成果のないアカウントを無効化し、振り分け効率を高めます）',
  'pages.workOrder.minUv': '最小UV',
  'pages.workOrder.minUvTooltip':
    '広告開始直後は 10 以上に設定することを推奨します。AI クローラートラフィックで無効化ルールが誤発動するのを防ぎます。',
  'pages.workOrder.minUvRequired': '最小UVを入力してください',
  'pages.workOrder.minUvPlaceholder': 'デフォルト 10',
  'pages.workOrder.flowOptimize':
    'フロー最適化（本日の友達追加しきい値に達したアカウントを自動で無効化）',
  'pages.workOrder.todayAddThreshold': '本日の友達追加しきい値',
  'pages.workOrder.todayAddThresholdTooltip':
    'このしきい値に達すると、システムはアカウントを「無効（フロー最適化）」に設定し、手動でのみ再有効化できます。',
  'pages.workOrder.todayAddThresholdRequired':
    '本日の友達追加しきい値を入力してください',
  'pages.workOrder.todayAddThresholdPlaceholder': '例: 10',
  'pages.workOrder.sihaiLoginTitle': '四海营销ログイン連携',
  'pages.workOrder.loginAndBind': 'ログインして連携',
  'pages.workOrder.username': 'ユーザー名',
  'pages.workOrder.usernameRequired': 'ユーザー名を入力してください',
  'pages.workOrder.usernamePlaceholder': 'ユーザー名を入力してください',
  'pages.workOrder.passwordRequired': 'パスワードを入力してください',
  'pages.workOrder.passwordInputPlaceholder': 'パスワードを入力してください',
  'pages.workOrder.captcha': '認証コード',
  'pages.workOrder.captchaRequired': '認証コードを入力してください',
  'pages.workOrder.captchaPlaceholder': '認証コードを入力してください',
  'pages.workOrder.refresh': '更新',
  'pages.workOrder.captchaAlt': '認証コード',
  'pages.workOrder.captchaLoadFailed':
    '認証コードの読み込みに失敗しました。更新をクリックしてください。',
  'pages.workOrder.importTitle': 'ワークオーダーデータをインポート',
  'pages.workOrder.importMethod': 'インポート方法',
  'pages.workOrder.importMethodRequired':
    'インポート方法を選択してください',
  'pages.workOrder.importModeNew': '新しいサービスを作成',
  'pages.workOrder.importModeExisting': '既存リンクへインポート',
  'pages.workOrder.selectService': 'サービスを選択',
  'pages.workOrder.selectServiceRequired':
    'インポート先のサービスを選択してください',
  'pages.workOrder.loading': '読み込み中...',
  'pages.workOrder.selectServicePlaceholder':
    'サービスを選択してください',
  'pages.workOrder.noAvailableServices': '利用可能なサービスがありません',
  'pages.workOrder.mergeMode': 'インポート方式',
  'pages.workOrder.mergeModeRequired':
    'インポート方式を選択してください',
  'pages.workOrder.mergeModeTooltip':
    'マージ: 既存アカウントを保持して新規アカウントを追加します（複数ワークオーダーで 1 つのサービスを共有可能）。置換: 既存アカウントをクリアして新規アカウントをインポートします（ワークオーダーデータを切り替えます）。',
  'pages.workOrder.merge': 'マージ（アカウントを追加）',
  'pages.workOrder.replace': '置換（クリアしてインポート）',
  'pages.workOrder.statusSessionBound': 'セッション連携済み',
  'pages.workOrder.statusSessionExpired': 'セッション期限切れ',
  'pages.workOrder.statusSessionUnbound': 'セッション未連携',
  'pages.workOrder.tooltipPaused': 'ワークオーダーは一時停止中です',
  'pages.workOrder.statusPaused': '一時停止',
  'pages.workOrder.statusPausedWithFailures':
    '一時停止（{count} 回失敗）',
  'pages.workOrder.tooltipFetchError': '取得時にエラーが発生しました',
  'pages.workOrder.statusRunning': '稼働中',
  'pages.workOrder.statusRunningWithFailures':
    '稼働中（{count} 回失敗）',
  'pages.workOrder.source.cloud': 'クラウド制御',
  'pages.workOrder.source.haiwang': '海王',
  'pages.workOrder.source.url99': 'Rocket',
  'pages.workOrder.source.url66': 'Rocket url66',
  'pages.workOrder.source.qukazhen': 'Qukazhen',
  'pages.workOrder.source.sihai': '四海营销',
  'pages.workOrder.source.xinghe': '星河クラウド制御',
  'pages.workOrder.source.a2c': 'A2Cクラウド制御',

  // Ad callback list
  'pages.adCallbackList.loadLandingPagesFailed':
    'ランディングページの読み込みに失敗しました',
  'pages.adCallbackList.enabledSuccess': '有効にしました',
  'pages.adCallbackList.disabledSuccess': '無効にしました',
  'pages.adCallbackList.operationFailed': '操作に失敗しました',
  'pages.adCallbackList.deleteSuccess': '削除しました',
  'pages.adCallbackList.deleteFailed': '削除に失敗しました',
  'pages.adCallbackList.landingPageMissing':
    '関連付けられたランディングページが見つかりません',
  'pages.adCallbackList.loadLandingPageDetailFailed':
    'ランディングページ情報の取得に失敗しました',
  'pages.adCallbackList.domainConfigMissing':
    'ドメイン設定がまだ読み込まれていません。しばらくしてから再試行してください。',
  'pages.adCallbackList.copyLinkSuccess':
    '広告リンクをクリップボードにコピーしました',
  'pages.adCallbackList.unknownError': '不明なエラー',
  'pages.adCallbackList.configName': '設定名',
  'pages.adCallbackList.aiLandingPage': 'AIランディングページ',
  'pages.adCallbackList.landingPage': 'ランディングページ',
  'pages.adCallbackList.unknownLandingPage':
    '不明なランディングページ',
  'pages.adCallbackList.eventConfig': 'イベント設定',
  'pages.adCallbackList.callbackConfig': 'コールバック設定',
  'pages.adCallbackList.dedup': '重複排除',
  'pages.adCallbackList.on': 'ON',
  'pages.adCallbackList.off': 'OFF',
  'pages.adCallbackList.ratio': '比率',
  'pages.adCallbackList.successFailed': '成功/失敗',
  'pages.adCallbackList.status': '状態',
  'pages.adCallbackList.actions': '操作',
  'pages.adCallbackList.copyCampaignLink': '広告リンクをコピー',
  'pages.adCallbackList.editConfig': '設定を編集',
  'pages.adCallbackList.viewStats': '統計を見る',
  'pages.adCallbackList.deleteConfig': '設定を削除',
  'pages.adCallbackList.deleteConfirmTitle':
    'この設定を削除してもよろしいですか？',
  'pages.adCallbackList.deleteConfirmDescription':
    'この操作は元に戻せず、関連する統計データも削除されます。',
  'pages.adCallbackList.deleteConfirmShort':
    'この設定を削除してもよろしいですか？',
  'pages.adCallbackList.confirm': '確認',
  'pages.adCallbackList.cancel': 'キャンセル',
  'pages.adCallbackList.batchDelete': '一括削除 ({count})',
  'pages.adCallbackList.cancelSelection': '選択を解除',
  'pages.adCallbackList.confirmDelete': '削除',
  'pages.adCallbackList.batchDeleteConfirmTitle':
    '選択した {count} 件のコールバック設定を削除しますか？',
  'pages.adCallbackList.batchDeleteConfirmContent':
    'この操作は元に戻せず、関連する統計データも削除されます。',
  'pages.adCallbackList.batchDeleteSuccess': '{count} 件のコールバック設定を削除しました',
  'pages.adCallbackList.batchDeletePartial':
    '{success} 件を削除し、{failed} 件は削除できませんでした',
  'pages.adCallbackList.batchDeleteFailed': '一括削除に失敗しました',
  'pages.adCallbackList.createConfig': '設定を作成',
  'pages.adCallbackList.searchConfigName': '設定名を検索',
  'pages.adCallbackList.search': '検索',
  'pages.adCallbackList.landingPageId': 'ランディングページID',
  'pages.adCallbackList.eventType': 'イベントタイプ',
  'pages.adCallbackList.createdAt': '作成日時',
  'pages.adCallbackList.todayClicks': '本日のクリック',
  'pages.adCallbackList.stats': '統計',
  'pages.adCallbackList.usageGuide': '利用ガイド',
  'pages.adCallbackList.googleGuideAlt': 'Google Ads 設定ガイド',
  'pages.adCallbackList.googleGuideText':
    '以下の画像は、Google Ads のコンバージョンコードを配置する場所と設定例を示しています。',
  'pages.adCallbackList.googleGuideImageNotice':
    '現在のガイド画像は中国語管理画面のものですが、英語版・日本語版でも設定手順は同じです。',
  'pages.adCallbackList.tiktokTitle': 'TikTok コールバック設定',
  'pages.adCallbackList.tiktokSubtitle':
    '複数チャネル広告向けの TikTok Events API コールバック設定を管理します',
  'pages.adCallbackList.tiktokHeaderTitle': 'TikTok 設定一覧',
  'pages.adCallbackList.facebookTitle': 'Facebook コールバック設定',
  'pages.adCallbackList.facebookSubtitle':
    '複数チャネル広告向けの Facebook Conversion API コールバック設定を管理します',
  'pages.adCallbackList.facebookHeaderTitle': 'Facebook 設定一覧',
  'pages.adCallbackList.bigoTitle': 'BigO コールバック設定',
  'pages.adCallbackList.bigoHeaderTitle': 'BigO 設定一覧',
  'pages.adCallbackList.googleTitle': 'Google コンバージョントラッキング',
  'pages.adCallbackList.googleHeaderTitle': 'Google 設定一覧',

  // Ad callback stats
  'pages.adCallbackStats.loadConfigFailed':
    '設定情報の読み込みに失敗しました',
  'pages.adCallbackStats.loadStatsFailed': '統計データの読み込みに失敗しました',
  'pages.adCallbackStats.exportSuccess': 'エクスポートしました',
  'pages.adCallbackStats.exportFailed': 'エクスポートに失敗しました',
  'pages.adCallbackStats.clearSuccess':
    '統計データをクリアしました',
  'pages.adCallbackStats.clearFailed': 'データのクリアに失敗しました',
  'pages.adCallbackStats.time': '時間',
  'pages.adCallbackStats.event': 'イベント',
  'pages.adCallbackStats.ipAddress': 'IP アドレス',
  'pages.adCallbackStats.pageUrl': 'ページ URL',
  'pages.adCallbackStats.status': '状態',
  'pages.adCallbackStats.success': '成功',
  'pages.adCallbackStats.failed': '失敗',
  'pages.adCallbackStats.loading': '読み込み中...',
  'pages.adCallbackStats.subTitle':
    'ルートコード: {routeCode} | プラットフォーム: {platform}',
  'pages.adCallbackStats.backToConfigs': '設定一覧へ戻る',
  'pages.adCallbackStats.exportData': 'データをエクスポート',
  'pages.adCallbackStats.resetData': 'データをリセット',
  'pages.adCallbackStats.refresh': '更新',
  'pages.adCallbackStats.timeRange': '期間:',
  'pages.adCallbackStats.totalEvents': '総イベント数',
  'pages.adCallbackStats.successEvents': '成功イベント数',
  'pages.adCallbackStats.failedEvents': '失敗イベント数',
  'pages.adCallbackStats.successRate': '成功率',
  'pages.adCallbackStats.eventBreakdown': 'イベント内訳',
  'pages.adCallbackStats.detailData': '詳細データ',
  'pages.adCallbackStats.totalRecords': '全 {total} 件',
  'pages.adCallbackStats.tiktokTitle': 'TikTok 統計 - {name}',
  'pages.adCallbackStats.facebookTitle': 'Facebook 統計 - {name}',
  'pages.adCallbackStats.bigoTitle': 'BigO 統計 - {name}',
  'pages.adCallbackStats.googleTitle': 'Google 統計 - {name}',
  'pages.adCallbackStats.googleSubtitle':
    'Google Ads コンバージョントラッキング統計',

  // Ad callback form
  'pages.adCallbackForm.loadLandingPagesFailed':
    'ランディングページの読み込みに失敗しました',
  'pages.adCallbackForm.parseLandingPageFailed':
    'ランディングページコンポーネントの解析に失敗しました',
  'pages.adCallbackForm.loadLandingPageDetailFailed':
    'ランディングページ詳細の読み込みに失敗しました',
  'pages.adCallbackForm.loadConfigFailed': '設定の読み込みに失敗しました',
  'pages.adCallbackForm.createSuccess': '作成しました',
  'pages.adCallbackForm.updateSuccess': '更新しました',
  'pages.adCallbackForm.createFailed': '作成に失敗しました',
  'pages.adCallbackForm.updateFailed': '更新に失敗しました',
  'pages.adCallbackForm.operationFailed': '操作に失敗しました',
  'pages.adCallbackForm.submitFailed': '送信に失敗しました',
  'pages.adCallbackForm.back': '戻る',
  'pages.adCallbackForm.backToList': '一覧へ戻る',
  'pages.adCallbackForm.cancel': 'キャンセル',
  'pages.adCallbackForm.save': '保存',
  'pages.adCallbackForm.create': '作成',
  'pages.adCallbackForm.update': '更新',
  'pages.adCallbackForm.basicConfig': '基本設定',
  'pages.adCallbackForm.callbackConfig': 'コールバック設定',
  'pages.adCallbackForm.apiConfig': '{platform} API 設定',
  'pages.adCallbackForm.configGuide': '設定ガイド',
  'pages.adCallbackForm.relatedLandingPage':
    '関連ランディングページ',
  'pages.adCallbackForm.landingPage': 'ランディングページ',
  'pages.adCallbackForm.landingPageRequired':
    'ランディングページを選択してください',
  'pages.adCallbackForm.landingPagePlaceholder':
    'ランディングページを選択してください',
  'pages.adCallbackForm.configName': '設定名',
  'pages.adCallbackForm.configNameRequired': '設定名を入力してください',
  'pages.adCallbackForm.remark': '備考',
  'pages.adCallbackForm.remarkPlaceholder':
    '任意です。設定の用途やチャネル情報を記録できます',
  'pages.adCallbackForm.optional': '任意',
  'pages.adCallbackForm.pixelId': 'Pixel ID',
  'pages.adCallbackForm.pixelIdRequired': 'Pixel ID を入力してください',
  'pages.adCallbackForm.accessToken': 'Access Token',
  'pages.adCallbackForm.accessTokenRequired':
    'Access Token を入力してください',
  'pages.adCallbackForm.eventType': 'イベントタイプ',
  'pages.adCallbackForm.eventTypeRequired':
    'イベントタイプを選択してください',
  'pages.adCallbackForm.eventTypePlaceholder':
    'イベントタイプを選択してください',
  'pages.adCallbackForm.reportEvent': '送信イベント',
  'pages.adCallbackForm.defaultValue': 'デフォルト金額',
  'pages.adCallbackForm.defaultValueRequired':
    'デフォルト金額を入力してください',
  'pages.adCallbackForm.defaultCurrency': 'デフォルト通貨',
  'pages.adCallbackForm.defaultCurrencyRequired':
    'デフォルト通貨を選択してください',
  'pages.adCallbackForm.defaultCurrencyPlaceholder':
    '通貨を選択してください',
  'pages.adCallbackForm.dedupIp': 'IP 重複排除',
  'pages.adCallbackForm.enabledText': 'ON',
  'pages.adCallbackForm.disabledText': 'OFF',
  'pages.adCallbackForm.callbackRatio': 'コールバック率 (%)',
  'pages.adCallbackForm.component': 'コンポーネント',
  'pages.adCallbackForm.selectComponent':
    'コンポーネントを選択',
  'pages.adCallbackForm.unnamedComponent':
    '名称未設定のコンポーネント',
  'pages.adCallbackForm.jumpUrl': '遷移 URL',
  'pages.adCallbackForm.enabled': '有効',
  'pages.adCallbackForm.actions': '操作',
  'pages.adCallbackForm.delete': '削除',
  'pages.adCallbackForm.jumpRuleConfigOptional':
    '遷移ルール設定（任意）',
  'pages.adCallbackForm.jumpRuleHintTitle': '遷移ルールの説明',
  'pages.adCallbackForm.jumpRuleHintDescription':
    'ランディングページ上のボタンや画像などのコンポーネントに動的な遷移 URL を設定できるため、異なるコールバック設定で同じランディングページを再利用できます。未設定の場合はランディングページ既定の設定を使用します。',
  'pages.adCallbackForm.selectLandingPageFirst':
    '先にランディングページを選択してください',
  'pages.adCallbackForm.selectLandingPageFirstDescription':
    'ランディングページを選択すると、そのページで利用可能なすべてのコンポーネントがここに表示され、遷移ルールを設定できます。',
  'pages.adCallbackForm.noAvailableComponents':
    'このランディングページには利用可能なコンポーネントがありません',
  'pages.adCallbackForm.noAvailableComponentsDescription':
    'このランディングページには、ボタンや画像など設定可能な遷移コンポーネントがありません。',
  'pages.adCallbackForm.addJumpRule': '遷移ルールを追加',
  'pages.adCallbackForm.component.floatingButton':
    'フローティングボタン',
  'pages.adCallbackForm.component.floatingButtonLabel':
    'フローティングボタン: {text}',
  'pages.adCallbackForm.component.heroButton1Label':
    'Hero ボタン 1: {text}',
  'pages.adCallbackForm.component.heroButton2Label':
    'Hero ボタン 2: {text}',
  'pages.adCallbackForm.component.transparentIconLabel':
    '透明アイコン: {text}',
  'pages.adCallbackForm.component.unnamed': '名称未設定',
  'pages.adCallbackForm.component.styleModulePrefix':
    'スタイルモジュール - ',
  'pages.adCallbackForm.component.buyButtonLabel':
    '購入ボタン: {text}',
  'pages.adCallbackForm.component.buyNow': '今すぐ購入',
  'pages.adCallbackForm.component.ecommercePrefix': '商品 - ',
  'pages.adCallbackForm.component.countdownPrefix':
    'カウントダウン - ',
  'pages.adCallbackForm.component.dialogPrefix': 'ダイアログ - ',
  'pages.adCallbackForm.component.formPrefix': 'フォーム - ',
  'pages.adCallbackForm.google.createTitle': 'Google 設定を作成',
  'pages.adCallbackForm.google.editTitle': 'Google 設定を編集',
  'pages.adCallbackForm.google.configNamePlaceholder':
    '例: WhatsApp コンバージョントラッキング',
  'pages.adCallbackForm.google.pixelCode': 'ピクセルコード',
  'pages.adCallbackForm.google.pixelCodePlaceholder':
    'Google Tag Manager や Google Analytics などのベース計測コードを含め、Google ピクセルコードをここに貼り付けてください',
  'pages.adCallbackForm.google.eventCode': 'イベントコード',
  'pages.adCallbackForm.google.eventCodePlaceholder':
    'Google Ads のコンバージョントラッキングコードなど、Google イベントコードをここに貼り付けてください',
  'pages.adCallbackForm.bigo.createTitle': 'BigO 設定を作成',
  'pages.adCallbackForm.bigo.editTitle': 'BigO 設定を編集',
  'pages.adCallbackForm.bigo.introTitle': 'BigO コールバック説明',
  'pages.adCallbackForm.bigo.introDescription':
    'BigO 広告プラットフォームの Pixel ID とイベントタイプを入力してください。bbg パラメータは URL から自動的に取得されます。',
  'pages.adCallbackForm.bigo.configNamePlaceholder':
    '例: 米国市場 - ボタンクリック',
  'pages.adCallbackForm.bigo.pixelIdPlaceholder':
    'BigO 広告 Pixel ID',
  'pages.adCallbackForm.bigo.event.button':
    'button (ボタンクリック)',
  'pages.adCallbackForm.bigo.event.consult': 'consult (相談)',
  'pages.adCallbackForm.bigo.event.ec_register':
    'ec_register (ユーザー登録)',
  'pages.adCallbackForm.bigo.event.ec_add_cart':
    'ec_add_cart (カート追加)',
  'pages.adCallbackForm.bigo.event.ec_order': 'ec_order (注文)',
  'pages.adCallbackForm.bigo.event.ec_purchase':
    'ec_purchase (購入完了)',
  'pages.adCallbackForm.bigo.event.form': 'form (フォーム送信)',
  'pages.adCallbackForm.bigo.event.phone_consult':
    'phone_consult (電話相談)',
  'pages.adCallbackForm.bigo.event.app_download':
    'app_download (ダウンロードクリック)',
  'pages.adCallbackForm.tiktok.createTitle': 'TikTok 設定を作成',
  'pages.adCallbackForm.tiktok.editTitle': 'TikTok 設定を編集',
  'pages.adCallbackForm.tiktok.subtitle':
    'TikTok Events API のコールバックパラメータと遷移ルールを設定します',
  'pages.adCallbackForm.tiktok.configNamePlaceholder':
    '例: TikTok 広告設定',
  'pages.adCallbackForm.tiktok.contentIdRule':
    'Content ID ルール',
  'pages.adCallbackForm.tiktok.contentIdRuleTooltip':
    'コールバック発火時に TikTok へ送信するパラメータです。迷う場合は既定値のままにしてください。',
  'pages.adCallbackForm.tiktok.fixedContentId':
    '固定 Content ID',
  'pages.adCallbackForm.tiktok.fixedContentIdRequired':
    '固定 Content ID を入力してください',
  'pages.adCallbackForm.tiktok.fixedContentIdPlaceholder':
    '固定 Content ID の値',
  'pages.adCallbackForm.tiktok.guideTitle':
    'TikTok API 設定ガイド',
  'pages.adCallbackForm.tiktok.guideDescription1':
    'TikTok 管理画面で Pixel を作成し、TikTok API コールバックを選択して Access Token を生成し、Access Token に貼り付けてください。',
  'pages.adCallbackForm.tiktok.guideDescription2':
    'Content ID ルールは、コールバック発火時に TikTok へ送信されるパラメータです。迷う場合は既定値のままにしてください。',
  'pages.adCallbackForm.tiktok.contentIdMode.pageId':
    'ランディングページ ID を使用',
  'pages.adCallbackForm.tiktok.contentIdMode.routeCode':
    'ルートコードを使用',
  'pages.adCallbackForm.tiktok.contentIdMode.fixed': '固定値',
  'pages.adCallbackForm.tiktok.event.clickButton':
    'ClickButton (ボタンクリック)',
  'pages.adCallbackForm.tiktok.event.submitForm':
    'SubmitForm (フォーム送信)',
  'pages.adCallbackForm.tiktok.event.contact': 'Contact (問い合わせ)',
  'pages.adCallbackForm.tiktok.event.viewContent':
    'ViewContent (ページビュー)',
  'pages.adCallbackForm.tiktok.event.completeRegistration':
    'CompleteRegistration (登録完了)',
  'pages.adCallbackForm.tiktok.event.addToCart':
    'AddToCart (カートに追加)',
  'pages.adCallbackForm.tiktok.event.addToWishlist':
    'AddToWishlist (ウィッシュリストに追加)',
  'pages.adCallbackForm.tiktok.event.initiateCheckout':
    'InitiateCheckout (購入手続き開始)',
  'pages.adCallbackForm.tiktok.event.addPaymentInfo':
    'AddPaymentInfo (支払い情報追加)',
  'pages.adCallbackForm.tiktok.event.placeAnOrder':
    'PlaceAnOrder (注文)',
  'pages.adCallbackForm.tiktok.event.completePayment':
    'CompletePayment (支払い完了)',
  'pages.adCallbackForm.tiktok.event.purchase': 'Purchase (購入完了)',
  'pages.adCallbackForm.tiktok.event.lead': 'Lead (見込み顧客)',
  'pages.adCallbackForm.tiktok.event.applicationApproval':
    'ApplicationApproval (申請承認)',
  'pages.adCallbackForm.tiktok.event.customizeProduct':
    'CustomizeProduct (製品カスタマイズ)',
  'pages.adCallbackForm.tiktok.event.download': 'Download (ダウンロード)',
  'pages.adCallbackForm.tiktok.event.findLocation':
    'FindLocation (場所を検索)',
  'pages.adCallbackForm.tiktok.event.schedule': 'Schedule (予約)',
  'pages.adCallbackForm.tiktok.event.search': 'Search (検索)',
  'pages.adCallbackForm.tiktok.event.startTrial': 'StartTrial (トライアル開始)',
  'pages.adCallbackForm.tiktok.event.submitApplication':
    'SubmitApplication (申請送信)',
  'pages.adCallbackForm.tiktok.event.subscribe': 'Subscribe (購読)',
  'pages.adCallbackForm.facebook.createTitle':
    'Facebook 設定を作成',
  'pages.adCallbackForm.facebook.editTitle': 'Facebook 設定を編集',
  'pages.adCallbackForm.facebook.subtitle':
    'Facebook Conversion API のコールバックパラメータと遷移ルールを設定します',
  'pages.adCallbackForm.facebook.configNamePlaceholder':
    '例: Facebook 広告設定',
  'pages.adCallbackForm.facebook.configDescriptionTitle':
    '設定説明',
  'pages.adCallbackForm.facebook.configDescriptionText':
    'Facebook Events Manager で Pixel を作成し、サーバーサイドイベントを選択して Access Token を生成し、Access Token に貼り付けてください。',
  'pages.adCallbackForm.facebook.testEventCode':
    'テストイベントコード（任意）',
  'pages.adCallbackForm.facebook.testEventCodeTooltip':
    'Facebook Event Testing Tool で使用します。本番環境では空欄のままにしてください。',
  'pages.adCallbackForm.facebook.testEventCodePlaceholder':
    'テストイベントコード',
  'pages.adCallbackForm.facebook.attributionShare':
    'アトリビューション比率',
  'pages.adCallbackForm.facebook.attributionShareTooltip':
    'コンバージョンの帰属比率です。特別な要件がなければ既定値のままにしてください。',
  'pages.adCallbackForm.facebook.guideTitle':
    'Facebook Conversion API 設定ガイド',
  'pages.adCallbackForm.facebook.guideDescription1':
    'Facebook 管理画面で手動 API を作成し、サーバー API イベントを選択して Access Token を生成し、Access Token に貼り付けてください。',
  'pages.adCallbackForm.facebook.guideDescription2':
    'Test Event Code は Facebook Event Testing Tool 用です。正式にイベントを有効化する際は入力しないでください。',
  'pages.adCallbackForm.facebook.event.pageView':
    'PageView (ページビュー)',
  'pages.adCallbackForm.facebook.event.viewContent':
    'ViewContent (コンテンツ閲覧)',
  'pages.adCallbackForm.facebook.event.addToCart':
    'AddToCart (カート追加)',
  'pages.adCallbackForm.facebook.event.addToWishlist':
    'AddToWishlist (ウィッシュリスト追加)',
  'pages.adCallbackForm.facebook.event.initiateCheckout':
    'InitiateCheckout (購入手続き開始)',
  'pages.adCallbackForm.facebook.event.purchase':
    'Purchase (購入)',
  'pages.adCallbackForm.facebook.event.lead':
    'Lead (見込み顧客)',
  'pages.adCallbackForm.facebook.event.completeRegistration':
    'CompleteRegistration (登録完了)',
  'pages.adCallbackForm.facebook.event.contact':
    'Contact (問い合わせ)',
  'pages.adCallbackForm.facebook.event.customizeProduct':
    'CustomizeProduct (商品カスタマイズ)',
  'pages.adCallbackForm.facebook.event.submitApplication':
    'SubmitApplication (申請送信)',
  'pages.adCallbackForm.facebook.event.startTrial':
    'StartTrial (トライアル開始)',
  'pages.adCallbackForm.facebook.event.schedule':
    'Schedule (予約)',
  'pages.adCallbackForm.facebook.event.subscribe':
    'Subscribe (購読)',
  'pages.adCallbackForm.facebook.event.custom':
    'Custom (カスタムイベント)',

  // SuperH pages
  'pages.superH.loadTikTokConfigsFailed':
    'TikTok 設定の読み込みに失敗しました。ネットワークを確認して再試行してください。',
  'pages.superH.loadConfigFailed':
    '設定詳細の読み込みに失敗しました。一覧へ戻って再試行してください。',
  'pages.superH.loadDataFailed':
    'データの読み込みに失敗しました。しばらくしてから再試行してください。',
  'pages.superH.startSuccess': '開始しました',
  'pages.superH.stopSuccess': '停止しました',
  'pages.superH.operationFailed': '操作に失敗しました',
  'pages.superH.deleteSuccess': '削除しました',
  'pages.superH.deleteFailed': '削除に失敗しました',
  'pages.superH.collectSuccess':
    '収集成功: {collectedCount} 件追加、合計 {totalCount} 件',
  'pages.superH.collectFailed': '収集に失敗しました',
  'pages.superH.loadProgressFailed':
    '進捗の取得に失敗しました',
  'pages.superH.configId': '設定ID: {id}',
  'pages.superH.name': '設定名',
  'pages.superH.sourceConfigs': '元設定',
  'pages.superH.targetConfig': '送信先設定',
  'pages.superH.sendInterval': '送信間隔',
  'pages.superH.sendIntervalSeconds': '{interval} 秒',
  'pages.superH.status': '状態',
  'pages.superH.statusRunning': '実行中',
  'pages.superH.statusStopped': '停止中',
  'pages.superH.actions': '操作',
  'pages.superH.start': '開始',
  'pages.superH.stop': '停止',
  'pages.superH.collectTtclid': 'ttclid を収集',
  'pages.superH.collect': '収集',
  'pages.superH.viewProgress': '進捗を見る',
  'pages.superH.progress': '進捗',
  'pages.superH.deleteConfig': '設定を削除',
  'pages.superH.deleteConfirmTitle':
    'この設定を削除してもよろしいですか？',
  'pages.superH.deleteConfirmDescription':
    'この操作は元に戻せず、関連する ttclid データも削除されます。',
  'pages.superH.confirm': '確認',
  'pages.superH.cancel': 'キャンセル',
  'pages.superH.title': 'スーパーコールバック設定',
  'pages.superH.subtitle':
    '元設定からコールバックデータを収集し、定期的に送信先設定へ送信します',
  'pages.superH.createConfig': '設定を作成',
  'pages.superH.headerTitle': 'スーパーコールバック設定一覧',
  'pages.superH.progressModalTitle': '実行進捗',
  'pages.superH.executionProgress': '実行進捗',
  'pages.superH.totalCount': '総数',
  'pages.superH.executedCount': '実行済み',
  'pages.superH.remainingCount': '残り',
  'pages.superH.lastExecuteTime': '最終実行時間',
  'pages.superH.refreshProgress': '進捗を更新',
  'pages.superH.editTitle': 'スーパーコールバック設定を編集',
  'pages.superH.createTitle': 'スーパーコールバック設定を作成',
  'pages.superH.breadcrumbAdCallback': '広告コールバック',
  'pages.superH.breadcrumbList': 'スーパーコールバック設定',
  'pages.superH.breadcrumbEdit': '設定を編集',
  'pages.superH.breadcrumbCreate': '設定を作成',
  'pages.superH.back': '戻る',
  'pages.superH.loading': '読み込み中...',
  'pages.superH.noTikTokConfigTitle':
    'TikTok 設定が見つかりません',
  'pages.superH.noTikTokConfigDescription':
    'スーパーコールバック設定を作成する前に、TikTok コールバック設定を 1 件以上作成してください。',
  'pages.superH.configName': '設定名',
  'pages.superH.configNameRequired': '設定名を入力してください',
  'pages.superH.configNamePlaceholder':
    'このスーパーコールバック設定の名前を入力してください',
  'pages.superH.remark': '備考',
  'pages.superH.remarkPlaceholder':
    '任意です。この設定の備考を入力してください',
  'pages.superH.sourceConfigsRequired':
    '元設定を 1 件以上選択してください',
  'pages.superH.sourceConfigsPlaceholder':
    '1 件以上の TikTok 設定をデータソースとして選択してください',
  'pages.superH.targetConfigRequired':
    '送信先設定を選択してください',
  'pages.superH.targetConfigConflict':
    '送信先設定は元設定と同じにできません',
  'pages.superH.targetConfigPlaceholder':
    '送信先となる TikTok 設定を選択してください',
  'pages.superH.sendIntervalLabel': '送信間隔（秒）',
  'pages.superH.sendIntervalRequired':
    '送信間隔を入力してください',
  'pages.superH.sendIntervalTooltip':
    '一括送信の頻度を制御します。範囲: 30〜120 秒。',
  'pages.superH.sendIntervalPlaceholder': '既定は 60 秒',
  'pages.superH.saveChanges': '変更を保存',

  // External callback pages
  'pages.externalCallback.enabledSuccess': '有効にしました',
  'pages.externalCallback.disabledSuccess': '無効にしました',
  'pages.externalCallback.operationFailed': '操作に失敗しました',
  'pages.externalCallback.deleteSuccess': '削除しました',
  'pages.externalCallback.deleteFailed': '削除に失敗しました',
  'pages.externalCallback.id': 'ID',
  'pages.externalCallback.name': '設定名',
  'pages.externalCallback.platform': 'プラットフォーム',
  'pages.externalCallback.pixelId': 'Pixel ID',
  'pages.externalCallback.eventType': 'イベントタイプ',
  'pages.externalCallback.callbackRatio': 'コールバック率',
  'pages.externalCallback.ipDedup': 'IP 重複排除',
  'pages.externalCallback.noDedup': '重複排除なし',
  'pages.externalCallback.dedupHours': '{hours} 時間',
  'pages.externalCallback.createdAt': '作成日時',
  'pages.externalCallback.status': '状態',
  'pages.externalCallback.actions': '操作',
  'pages.externalCallback.on': '有効',
  'pages.externalCallback.off': '無効',
  'pages.externalCallback.stats': '統計',
  'pages.externalCallback.editConfig': '設定を編集',
  'pages.externalCallback.deleteConfig': '設定を削除',
  'pages.externalCallback.deleteConfirmTitle':
    'この設定を削除してもよろしいですか？',
  'pages.externalCallback.deleteConfirmDescription':
    'この操作は元に戻せません。',
  'pages.externalCallback.confirm': '確認',
  'pages.externalCallback.cancel': 'キャンセル',
  'pages.externalCallback.title': '外部 URL コールバック設定',
  'pages.externalCallback.domainConfig': 'ドメイン設定',
  'pages.externalCallback.createConfig': '設定を作成',
  'pages.externalCallback.headerTitle': '外部コールバック設定一覧',
  'pages.externalCallback.searchConfigName': '設定名を検索',
  'pages.externalCallback.search': '検索',
  'pages.externalCallback.loadConfigFailed':
    '設定の読み込みに失敗しました',
  'pages.externalCallback.updateSuccess': '更新しました',
  'pages.externalCallback.createSuccess': '作成しました',
  'pages.externalCallback.submitFailed': '送信に失敗しました',
  'pages.externalCallback.editTitle': '外部コールバック設定を編集',
  'pages.externalCallback.createTitle': '外部コールバック設定を作成',
  'pages.externalCallback.back': '戻る',
  'pages.externalCallback.save': '保存',
  'pages.externalCallback.introTitle': '外部 URL コールバック説明',
  'pages.externalCallback.introDescription':
    'この設定は外部 URL 斗篷機能で使用します。顧客は独自の外部ランディングページで JS SDK からコールバック API を呼び出し、システムが選択した広告プラットフォームへ自動でコールバックを送信します。',
  'pages.externalCallback.configName': '設定名',
  'pages.externalCallback.configNameRequired':
    '設定名を入力してください',
  'pages.externalCallback.configNamePlaceholder':
    '例: TikTok - 米国市場',
  'pages.externalCallback.remark': '備考',
  'pages.externalCallback.remarkPlaceholder':
    '設定説明（任意）',
  'pages.externalCallback.platformRequired':
    '広告プラットフォームを選択してください',
  'pages.externalCallback.platformPlaceholder':
    '広告プラットフォームを選択してください',
  'pages.externalCallback.pixelIdRequired':
    'Pixel ID を入力してください',
  'pages.externalCallback.pixelIdPlaceholder':
    '広告プラットフォームの Pixel ID',
  'pages.externalCallback.accessToken': 'Access Token',
  'pages.externalCallback.accessTokenRequired':
    'Access Token を入力してください',
  'pages.externalCallback.accessTokenPlaceholder':
    '広告プラットフォームのアクセストークン',
  'pages.externalCallback.eventTypeRequired':
    'イベントタイプを選択してください',
  'pages.externalCallback.eventTypePlaceholder':
    'イベントタイプを選択してください',
  'pages.externalCallback.selectPlatformFirst':
    '先に広告プラットフォームを選択してください',
  'pages.externalCallback.callbackRatioRequired':
    'コールバック率を設定してください',
  'pages.externalCallback.callbackRatioHelp':
    'コールバック送信割合を設定します。100 は全件送信、50 は 50% の確率で送信、0 は送信しません。',
  'pages.externalCallback.defaultValue': 'デフォルト金額',
  'pages.externalCallback.defaultValueRequired':
    'デフォルト金額を入力してください',
  'pages.externalCallback.defaultValueHelp':
    'JS SDK 呼び出し時に金額が渡されなかった場合、このデフォルト値を使用します',
  'pages.externalCallback.defaultCurrency': 'デフォルト通貨',
  'pages.externalCallback.defaultCurrencyRequired':
    'デフォルト通貨を選択してください',
  'pages.externalCallback.defaultCurrencyPlaceholder':
    '通貨を選択してください',
  'pages.externalCallback.enableDedup': 'IP 重複排除',
  'pages.externalCallback.statsTitle':
    'コールバック統計 - {name}',
  'pages.externalCallback.backToList': '一覧へ戻る',
  'pages.externalCallback.loadConfigInfoFailed':
    '設定情報の読み込みに失敗しました',
  'pages.externalCallback.loadStatsFailed':
    '統計データの読み込みに失敗しました',
  'pages.externalCallback.event': 'イベント',
  'pages.externalCallback.success': '成功',
  'pages.externalCallback.failed': '失敗',
  'pages.externalCallback.ip': 'IP',
  'pages.externalCallback.requestId': 'リクエスト ID',
  'pages.externalCallback.time': '時間',
  'pages.externalCallback.totalCallbacks': '総コールバック数',
  'pages.externalCallback.successCount': '成功数',
  'pages.externalCallback.failedCount': '失敗数',
  'pages.externalCallback.successRate': '成功率',
  'pages.externalCallback.dateRange': '期間:',
  'pages.externalCallback.query': '検索',
  'pages.externalCallback.totalRecords': '全 {total} 件',

  // Landing page list
  'pages.landingPageList.loadDomainsFailed': 'ドメイン設定の読み込みに失敗しました',
  'pages.landingPageList.accessCodeMissing': 'アクセスコードが存在しません',
  'pages.landingPageList.domainConfigMissing':
    'ドメイン設定がまだ読み込まれていません。しばらくしてから再試行してください',
  'pages.landingPageList.linkCopied': 'リンクをクリップボードにコピーしました',
  'pages.landingPageList.unknownError': '不明なエラー',
  'pages.landingPageList.copyLinkFailed': 'コピーに失敗しました: {message}',
  'pages.landingPageList.copySuccess': 'コピーしました',
  'pages.landingPageList.copyFailed': 'コピーに失敗しました: {message}',
  'pages.landingPageList.copyFailedShort': 'コピーに失敗しました',
  'pages.landingPageList.deleteSuccess': '削除しました',
  'pages.landingPageList.deleteFailed': '削除に失敗しました: {message}',
  'pages.landingPageList.deleteFailedShort': '削除に失敗しました',
  'pages.landingPageList.batchDelete': '一括削除',
  'pages.landingPageList.batchDeleteWithCount': '一括削除 ({count})',
  'pages.landingPageList.batchDeleteEmpty':
    '削除するランディングページを選択してください',
  'pages.landingPageList.batchDeleteConfirmTitle':
    '選択した {count} 件のランディングページを削除しますか？',
  'pages.landingPageList.batchDeleteConfirmContent':
    'この操作は元に戻せません。公開済みリンクも利用できなくなります。',
  'pages.landingPageList.batchDeleteSuccess':
    '{count} 件のランディングページを削除しました',
  'pages.landingPageList.batchDeleteFailed':
    '一括削除に失敗しました: {message}',
  'pages.landingPageList.batchDeleteFailedShort': '一括削除に失敗しました',
  'pages.landingPageList.publishSuccess': '公開しました',
  'pages.landingPageList.publishCancelled': '公開を取り消しました',
  'pages.landingPageList.publishFailed': '公開に失敗しました: {message}',
  'pages.landingPageList.operationFailed': '操作に失敗しました: {message}',
  'pages.landingPageList.operationFailedShort': '操作に失敗しました',
  'pages.landingPageList.accessCodeGenerated':
    'アクセスコードを生成しました。ページを更新してから再度コピーしてください',
  'pages.landingPageList.accessCodeGenerateFailed':
    'アクセスコードの生成に失敗しました: {message}',
  'pages.landingPageList.accessCodeGenerateRetry':
    'アクセスコードの生成に失敗しました。しばらくしてから再試行してください',
  'pages.landingPageList.preview': 'プレビュー',
  'pages.landingPageList.noImage': '画像なし',
  'pages.landingPageList.page': 'ランディングページ',
  'pages.landingPageList.identifier': '識別子',
  'pages.landingPageList.status': '状態',
  'pages.landingPageList.published': '公開済み',
  'pages.landingPageList.draft': '下書き',
  'pages.landingPageList.createdAt': '作成日時',
  'pages.landingPageList.actions': '操作',
  'pages.landingPageList.publish': '公開',
  'pages.landingPageList.unpublish': '公開を取り消す',
  'pages.landingPageList.copyLink': 'リンクをコピー',
  'pages.landingPageList.more': 'その他',
  'pages.landingPageList.edit': '編集',
  'pages.landingPageList.copyLandingPage': 'ランディングページを複製',
  'pages.landingPageList.generateQr': 'QRコード生成',
  'pages.landingPageList.delete': '削除',
  'pages.landingPageList.deleteConfirmTitle':
    'このランディングページを削除してもよろしいですか？',
  'pages.landingPageList.deleteConfirmContent':
    'この操作は元に戻せません',
  'pages.landingPageList.confirm': '確認',
  'pages.landingPageList.cancel': 'キャンセル',
  'pages.landingPageList.title': 'ランディングページ一覧',
  'pages.landingPageList.searchPlaceholder': 'タイトルまたは短縮コードを検索',
  'pages.landingPageList.viewStats': 'アクセス統計',
  'pages.landingPageList.createPage': '新しいページを作成',
  'pages.landingPageList.totalRecords': '全 {total} 件',

  // Form management
  'pages.formManagement.loadLandingPagesFailed':
    'ランディングページ一覧の読み込みに失敗しました',
  'pages.formManagement.loadFailed': '読み込みに失敗しました: {message}',
  'pages.formManagement.loadRetry':
    '読み込みに失敗しました。しばらくしてから再試行してください',
  'pages.formManagement.deleteSuccess': '削除しました',
  'pages.formManagement.deleteFailed': '削除に失敗しました: {message}',
  'pages.formManagement.deleteRetry':
    '削除に失敗しました。しばらくしてから再試行してください',
  'pages.formManagement.exportSuccess': 'エクスポートしました',
  'pages.formManagement.exportFailed': 'エクスポートに失敗しました: {message}',
  'pages.formManagement.selectLandingPageWarning':
    '少なくとも 1 件のランディングページを選択してください',
  'pages.formManagement.shareLinkCreated':
    '共有リンクを作成しました',
  'pages.formManagement.shareLinkCreateFailed':
    '共有リンクの作成に失敗しました: {message}',
  'pages.formManagement.shareLinkCreateRetry':
    '共有リンクの作成に失敗しました。しばらくしてから再試行してください',
  'pages.formManagement.shareLinkCopied':
    '共有リンクをクリップボードにコピーしました',
  'pages.formManagement.copyRetry':
    'コピーに失敗しました。手動でコピーしてください',
  'pages.formManagement.clearSuccess': 'クリアしました',
  'pages.formManagement.clearQueued':
    'クリア処理をバックグラウンドキューに追加しました。ページは引き続き操作できます',
  'pages.formManagement.clearSuccessWithCount':
    'クリアが完了しました。{count} 件のフォーム記録を削除しました',
  'pages.formManagement.clearTimeout':
    'バックグラウンドでクリア処理を続行しています。後ほど更新してください',
  'pages.formManagement.clearFailed': 'クリアに失敗しました: {message}',
  'pages.formManagement.clearRetry':
    'クリアに失敗しました。しばらくしてから再試行してください',
  'pages.formManagement.manualCallbackSuccess': 'コールバックしました',
  'pages.formManagement.manualCallbackFailed':
    'コールバックに失敗しました: {message}',
  'pages.formManagement.manualCallbackRetry':
    'コールバックに失敗しました。しばらくしてから再試行してください',
  'pages.formManagement.unnamedSku': '名称未設定の SKU',
  'pages.formManagement.title': 'フォーム管理',
  'pages.formManagement.aiLandingPage': 'AIランディングページ',
  'pages.formManagement.pageType': 'ランディングページの種類',
  'pages.formManagement.allPageTypes': 'すべての種類',
  'pages.formManagement.builderLandingPage': '通常のランディングページ',
  'pages.formManagement.clearIgnoresFilters': '現在の絞り込み条件に関係なく、このアカウントのすべてのフォームが削除されます。',
  'pages.formManagement.range.all': 'すべて',
  'pages.formManagement.range.today': '今日',
  'pages.formManagement.range.7d': '過去 7 日',
  'pages.formManagement.range.30d': '過去 30 日',
  'pages.formManagement.selectLandingPage': 'ランディングページを選択',
  'pages.formManagement.allLandingPages': 'すべてのランディングページ',
  'pages.formManagement.shareForm': 'フォーム共有',
  'pages.formManagement.exportCsv': 'CSV をエクスポート',
  'pages.formManagement.clearForm': 'フォームをクリア',
  'pages.formManagement.clearConfirmTitle':
    'すべてのフォーム記録をクリアしてもよろしいですか？',
  'pages.formManagement.clearConfirmDescription':
    'この操作は元に戻せず、すべてのフォーム送信記録が完全に削除されます',
  'pages.formManagement.clearConfirmOk': 'すべてクリア',
  'pages.formManagement.refresh': '更新',
  'pages.formManagement.monthlyForms': '今月のフォーム',
  'pages.formManagement.dailyForms': '本日のフォーム',
  'pages.formManagement.uniqueUv': 'ユニーク UV',
  'pages.formManagement.submitTime': '送信日時',
  'pages.formManagement.urlSource': '参照元 URL',
  'pages.formManagement.directVisit': '直接アクセス',
  'pages.formManagement.location': '所在地',
  'pages.formManagement.unknown': '不明',
  'pages.formManagement.sku': 'SKU',
  'pages.formManagement.callbackStatus': 'コールバック状態',
  'pages.formManagement.callback.pending': '待機中',
  'pages.formManagement.callback.success': '送信済み',
  'pages.formManagement.callback.failed': '送信失敗',
  'pages.formManagement.callback.skipped': '自動',
  'pages.formManagement.actions': '操作',
  'pages.formManagement.view': '表示',
  'pages.formManagement.manualCallback': 'コールバック',
  'pages.formManagement.manualCallbackConfirm':
    '手動コールバックを実行してもよろしいですか？',
  'pages.formManagement.delete': '削除',
  'pages.formManagement.deleteConfirm':
    'この記録を削除してもよろしいですか？',
  'pages.formManagement.totalRecords': '全 {total} 件',
  'pages.formManagement.detailTitle': 'フォーム詳細',
  'pages.formManagement.close': '閉じる',
  'pages.formManagement.landingPage': 'ランディングページ',
  'pages.formManagement.pageId': 'ページ ID: {id}',
  'pages.formManagement.ipAddress': 'IP アドレス',
  'pages.formManagement.device': 'デバイス',
  'pages.formManagement.formData': 'フォームデータ',
  'pages.formManagement.shareTitle': 'フォームデータ共有',
  'pages.formManagement.selectPagesToShare':
    '共有するランディングページを選択してください:',
  'pages.formManagement.createShareLink': '共有リンクを生成',
  'pages.formManagement.shareLink': '共有リンク:',
  'pages.formManagement.copy': 'コピー',
  'pages.formManagement.shareHint':
    'このリンクはログインなしで直接開けます。リンクを知っている人は誰でも選択したランディングページのフォームデータを閲覧できます。',
  'pages.formManagement.unknownDevice': '不明なデバイス',
  'pages.formManagement.device.androidPhone': 'Android スマートフォン',
  'pages.formManagement.device.androidTablet': 'Android タブレット',

  'pages.landingPageStats.dataCenter': 'データセンター',
  'pages.landingPageStats.dataCenterHint': 'システムパラメータのデータセンター IP/CIDR リストに一致',
  'pages.landingPageStats.visitsSubtitle': 'アクセス日時順に各記録を表示。ページ別の絞り込みも可能です',
  'pages.landingPageStats.filterPage': 'ページで絞り込み',
  'pages.landingPageStats.filterPagePlaceholder': '全ページ · タイトルまたは ID で検索',
  'pages.landingPageStats.loadingPages': 'ページを読み込み中…',
  'pages.landingPageStats.narrowPageSearch': '最初の50件を表示中。タイトルを絞るか ID で検索してください。',
  'pages.landingPageStats.loadPagesFailed': 'ページ一覧の読み込みに失敗しました',
  'pages.landingPageStats.filterThisPage': 'このページのアクセスのみ表示',
  'pages.landingPageStats.duration': '滞在時間',
  'pages.landingPageStats.durationSeconds': '{seconds} 秒',
  'pages.landingPageStats.allPages': '全ページを表示',
  'pages.landingPageStats.export': 'エクスポート',
  'pages.landingPageStats.exporting': 'エクスポート中',
  'pages.landingPageStats.cancelExport': 'エクスポートを中止',
  'pages.landingPageStats.exportPageHint': 'ランディングページを選択すると CSV を出力できます',
  'pages.landingPageStats.exportScopeHint': '選択期間内のこのページの全アクセス記録を CSV に出力',
  'pages.landingPageStats.exportFailed': 'エクスポートに失敗しました：{message}',
  'pages.landingPageStats.exportInvalidResponse': '出力ファイルが無効です。もう一度お試しください。',
  'pages.landingPageStats.visitRecords': 'アクセス記録',
  'pages.landingPageStats.visitsNewestFirst': '新しいアクセス日時順',
  'pages.landingPageStats.visitPageInfo': '{page} ページ目 · 表示 {count} 件',
  'pages.landingPageStats.pageSize': '表示件数',
  'pages.landingPageStats.rowsPerPage': '{count} 件 / ページ',
  'pages.landingPageStats.previousPage': '前へ',
  'pages.landingPageStats.nextPage': '次へ',
  'pages.landingPageStats.subtitle': '日付別のアクセスデータを通常ページと AI ページに分けて表示',
  'pages.landingPageStats.regularPages': '通常ランディングページ',
  'pages.landingPageStats.aiPages': 'AI ランディングページ',
  'pages.landingPageStats.today': '今日',
  'pages.landingPageStats.yesterday': '昨日',
  'pages.landingPageStats.last7Days': '直近7日間',
  'pages.landingPageStats.dateHint': 'システムのタイムゾーン基準。直近7日間には今日を含みます',
  'pages.landingPageStats.retry': '再試行',
  'pages.landingPageStats.pv': '閲覧数（PV）',
  'pages.landingPageStats.uv': '訪問者数（UV）',
  'pages.landingPageStats.uniqueIp': 'ユニーク IP',
  'pages.landingPageStats.uvHint': '日付・ルート・IP ごとに重複を除外。7日間の UV は日別訪問者数の合計です。',
  'pages.landingPageStats.pageCount': 'この種類のページ総数',
  'pages.landingPageStats.visiblePv': '表示中の閲覧数（PV）',
  'pages.landingPageStats.visibleUv': '表示中の訪問者数（UV）',
  'pages.landingPageStats.newestFirst': 'ページ ID の新しい順',
  'pages.landingPageStats.visibleHint': '上の PV / UV は現在の一覧に表示中のページの合計です。ページ送りで変わり、複数のページへの訪問は個別に計上されます。',
  'pages.landingPageStats.noPages': 'この種類のページはありません',
  'pages.landingPageStats.noVisits': '選択期間内のアクセスはありません',
  'pages.landingPageStats.visitedAt': 'アクセス日時',
  'pages.landingPageStats.routeCode': 'ルートコード',
  'pages.landingPageStats.visitStatus': 'アクセス状態',
  'pages.landingPageStats.blocked': 'ブロック済み',
  'pages.landingPageStats.visited': 'アクセス済み',
  'pages.landingPageStats.detailRangeHint': '選択期間内のアクセスのみ表示',
  'pages.landingPageStats.mobile': 'モバイル',
  'pages.landingPageStats.desktop': 'デスクトップ',
  'pages.landingPageStats.title': 'ランディングページアクセス統計',
  'pages.landingPageStats.refresh': '更新',
  'pages.landingPageStats.monthlyPv': '直近7日間の PV',
  'pages.landingPageStats.monthlyUv': '直近7日間の UV',
  'pages.landingPageStats.todayUv': '本日の UV',
  'pages.landingPageStats.recentDevices': '直近7日間のアクセス端末（Top 5）',
  'pages.landingPageStats.recentCountries': '直近7日間のアクセス国（Top 5）',
  'pages.landingPageStats.noData': 'データがありません',
  'pages.landingPageStats.landingPageTitle': 'ランディングページタイトル',
  'pages.landingPageStats.tableUv': '直近7日間の UV',
  'pages.landingPageStats.tablePv': '直近7日間の PV',
  'pages.landingPageStats.pageId': 'ID: {id}',
  'pages.landingPageStats.lastVisit': '最終アクセス',
  'pages.landingPageStats.actions': '操作',
  'pages.landingPageStats.details': '詳細',
  'pages.landingPageStats.ipAddress': 'IP アドレス',
  'pages.landingPageStats.location': '地域',
  'pages.landingPageStats.unknown': '不明',
  'pages.landingPageStats.source': '参照元',
  'pages.landingPageStats.visitDate': 'アクセス日',
  'pages.landingPageStats.visitTime': 'アクセス時間',
  'pages.landingPageStats.device': 'デバイス',
  'pages.landingPageStats.totalRecords': '全 {total} 件',
  'pages.landingPageStats.detailTitle': 'アクセス詳細 - {title}',
  'pages.landingPageStats.rangeStats': '期間統計を表示',
  'pages.landingPageStats.loadSummaryFailed':
    '統計サマリーの読み込みに失敗しました: {message}',
  'pages.landingPageStats.loadDetailFailed':
    'アクセス詳細の読み込みに失敗しました: {message}',
  'pages.landingPageStats.loadRangeFailed':
    '期間統計の読み込みに失敗しました: {message}',
  'pages.landingPageStats.loadRetry':
    '読み込みに失敗しました。しばらくしてから再試行してください',
  'pages.landingPageStats.unknownError': '不明なエラー',

  'pages.landingPageTemplates.status.draft': '下書き',
  'pages.landingPageTemplates.status.published': '公開済み',
  'pages.landingPageTemplates.loadBaseUrlRetry':
    'ランディングページドメインの読み込みに失敗しました。システムドメイン設定を確認してください。',
  'pages.landingPageTemplates.fetchDataFailed':
    'テンプレートデータを取得できませんでした',
  'pages.landingPageTemplates.loadTemplatesRetry':
    'テンプレートの読み込みに失敗しました。しばらくしてから再試行してください。',
  'pages.landingPageTemplates.loadLandingPagesFailed':
    'ランディングページ一覧の読み込みに失敗しました',
  'pages.landingPageTemplates.updateSuccess':
    'テンプレートを更新しました',
  'pages.landingPageTemplates.createSuccess':
    'テンプレートを作成しました',
  'pages.landingPageTemplates.deleteSuccess': '削除しました',
  'pages.landingPageTemplates.deleteConfirmTitle':
    'テンプレート「{title}」を削除しますか？',
  'pages.landingPageTemplates.copyTitle': '{title} - コピー',
  'pages.landingPageTemplates.copySuccess':
    'テンプレートを複製しました',
  'pages.landingPageTemplates.copyFailed':
    'テンプレートの複製に失敗しました',
  'pages.landingPageTemplates.copyRetry':
    'テンプレートの複製に失敗しました。しばらくしてから再試行してください。',
  'pages.landingPageTemplates.permissionDenied':
    'この操作を行う権限がありません',
  'pages.landingPageTemplates.previewFrameTitle': 'プレビュー: {id}',
  'pages.landingPageTemplates.noPreview': 'プレビューはありません',
  'pages.landingPageTemplates.domainNotConfigured':
    'ランディングページドメインが未設定です',
  'pages.landingPageTemplates.previewDomainError':
    'ランディングページドメインが未設定です。管理者に連絡してください。',
  'pages.landingPageTemplates.previewUnavailable':
    'このテンプレートにはまだプレビューがありません',
  'pages.landingPageTemplates.copyTemplate': 'テンプレートを複製',
  'pages.landingPageTemplates.previewTemplate': 'テンプレートをプレビュー',
  'pages.landingPageTemplates.editTemplate': 'テンプレート情報を編集',
  'pages.landingPageTemplates.deleteTemplate': 'テンプレートを削除',
  'pages.landingPageTemplates.copy': 'コピー',
  'pages.landingPageTemplates.preview': 'プレビュー',
  'pages.landingPageTemplates.edit': '編集',
  'pages.landingPageTemplates.delete': '削除',
  'pages.landingPageTemplates.createCustomTemplate':
    'カスタムテンプレートを作成',
  'pages.landingPageTemplates.loading': 'テンプレートを読み込み中...',
  'pages.landingPageTemplates.empty':
    'まだテンプレートがありません。しばらくしてから再試行してください。',
  'pages.landingPageTemplates.latestTitle': '最新テンプレート',
  'pages.landingPageTemplates.latestSubtitle': '新しく追加されたランディングページデザイン',
  'pages.landingPageTemplates.aiExamples': 'AI ランディングページ事例',
  'pages.landingPageTemplates.aiExamplesSubtitle': 'AI が生成したページ案をワンクリックで複製',
  'pages.landingPageTemplates.emptyAIExamples': 'AI ランディングページ事例はまだありません。',
  'pages.landingPageTemplates.usageTip':
    '使い方: テンプレートライブラリ内の任意のランディングページスタイルをそのまま複製し、その後コンポーネントを微調整して必要な形に仕上げられます。',
  'pages.landingPageTemplates.allTemplates': '📋 すべてのテンプレート',
  'pages.landingPageTemplates.refresh': '更新',
  'pages.landingPageTemplates.editTitle': 'テンプレートを編集',
  'pages.landingPageTemplates.createTitle': 'テンプレートを作成',
  'pages.landingPageTemplates.save': '保存',
  'pages.landingPageTemplates.create': '作成',
  'pages.landingPageTemplates.cancel': 'キャンセル',
  'pages.landingPageTemplates.sourceLandingPage': '元のランディングページ',
  'pages.landingPageTemplates.sourceLandingPageRequired':
    '元のランディングページを選択してください',
  'pages.landingPageTemplates.sourceLandingPagePlaceholder':
    '既存のランディングページを選択',
  'pages.landingPageTemplates.templateName': 'テンプレート名',
  'pages.landingPageTemplates.templateNameRequired':
    'テンプレート名を入力してください',
  'pages.landingPageTemplates.templateNamePlaceholder':
    '例: ブラックフライデー EC テンプレート',
  'pages.landingPageTemplates.templateDescription':
    'テンプレート説明',
  'pages.landingPageTemplates.templateDescriptionPlaceholder':
    'テンプレート紹介または推奨利用シーン',
  'pages.landingPageTemplates.tags': 'タグ',
  'pages.landingPageTemplates.tagsPlaceholder':
    '入力後 Enter でタグを追加',
  'pages.landingPageTemplates.minVipLevel': '最低 VIP レベル',
  'pages.landingPageTemplates.minVipLevelRequired':
    'VIP レベルを選択してください',
  'pages.landingPageTemplates.vipPlaceholder':
    '必要な VIP 権限を選択',
  'pages.landingPageTemplates.status': '状態',
  'pages.landingPageTemplates.applyTitle':
    'テンプレートを複製してランディングページを生成',
  'pages.landingPageTemplates.generateLandingPage':
    'ランディングページを生成',
  'pages.landingPageTemplates.newLandingPageName':
    '新しいランディングページ名',
  'pages.landingPageTemplates.nameRequired': '名称を入力してください',
  'pages.landingPageTemplates.newLandingPageNamePlaceholder':
    '例: ブラックフライデーテンプレート - 自分用',
  'pages.landingPageTemplates.landingPageDescription':
    'ランディングページ説明',
  'pages.landingPageTemplates.landingPageDescriptionPlaceholder':
    '任意。このランディングページの用途を記録できます',
  'pages.landingPageTemplates.groupName': 'グループ名',
  'pages.landingPageTemplates.groupNamePlaceholder':
    'ランディングページのグループ管理用',
  'pages.landingPageTemplates.groupColor': 'グループカラー',
  'pages.landingPageTemplates.groupColorPlaceholder':
    '例: #1890FF',
  'pages.landingPageTemplates.seoTitle': 'SEO タイトル',
  'pages.landingPageTemplates.seoTitlePlaceholder':
    'テンプレートのデフォルト SEO タイトルを上書き',
  'pages.landingPageTemplates.seoDescription': 'SEO 説明',
  'pages.landingPageTemplates.seoDescriptionPlaceholder':
    'テンプレートのデフォルト SEO 説明を上書き',
  'pages.landingPageTemplates.seoKeywords': 'SEO キーワード',
  'pages.landingPageTemplates.seoKeywordsPlaceholder':
    '複数キーワードはカンマ区切り',
  'pages.landingPageTemplates.customCode': 'カスタムコード',
  'pages.landingPageTemplates.customCodePlaceholder':
    '広告ピクセルやカスタムスクリプトをここに追加',
};
